<template>
    <v-app>
        <div v-if="$route.name === 'login' || $route.name === 'register' || $route.name === 'anasirket' || $route.name === 'login-uye' || $route.name ==='uye-detay' || $route.name ==='uye-yeni' || $route.name === 'login-yetkigrup' || $route.name === 'login-yetkigruplist' || $route.name === 'confirm' || $route.name === 'hataodeme' || $route.name === 'basarili' || $route.name === 'urunsatinal' || $route.name === 'urunsatis' || $route.name === 'coper-clinistaliste' || $route.name === 'coper-clinistaislem' || $route.name === 'coper-clinista-takvim'  || $route.name === 'odeme-sonuc'">
            <router-view></router-view>
        </div>
        <div v-else>
    
            
    
            <gizlilikSozlesme ref="gizlilikSozlesme"></gizlilikSozlesme>
            <aydinlatmaSozlesme ref="aydinlatmaSozlesme"></aydinlatmaSozlesme>
            <musteriraporlink ref="musteriraporlink"></musteriraporlink>
            <kontorlerDialog ref="kontorlerDialog"></kontorlerDialog> 
            <yardimciIslemDialog ref="yardimciIslemDialog"></yardimciIslemDialog>
          
            <v-navigation-drawer v-if="this.nextMuhasebe==false"  persistent :mini-variant="miniVariant" width="245" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed="" app>
                <v-list dense>
                    <template  v-for="item in items" > 
                        <v-list-group v-if="item.items" :key="item.title" :prepend-icon="item.icon"  no-action>
                            <v-list-tile slot="activator">
                                <v-list-tile-content>
                                    <v-list-tile-title> {{ item.title }} </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <template v-for="(subItem, i) in item.items">
                                <!--sub group-->
                                <v-list-group v-if="subItem.items" :group="subItem.group" :sub-group="true" :key="subItem.title" >
                                    <v-list-tile slot="activator" ripple="ripple">
                                        <v-list-tile-content>
                                         <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                        </v-list-tile-content>
                                          <v-list-tile-action ripple="ripple">
                                            <v-icon>{{ subItem.icon }} </v-icon> 
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <template v-for="(grand, i) in subItem.items" ripple="ripple">
                                        <v-list-group v-if="grand.items" :group="grand.group" :sub-group="true" :key="grand.title">
                                            <v-list-tile slot="activator" ripple="ripple">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ grand.title }} </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <template v-for="(gsub, i) in grand.items" ripple="ripple">
                                              <v-list-group v-if="gsub.items" :group="gsub.group" :sub-group="true" :key="gsub.title" >
                                                <!-- Yeni satış menu-->
                                            <v-list-tile slot="activator" ripple="ripple">
                                               <!-- <v-list-tile :key="i" :to="{ name: gsub.to }">  -->
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsub.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <template v-for="(gsubunder,q) in gsub.items" ripple="ripple" >
                                                  <v-list-tile :key="q" :to="{ name: gsubunder.to }">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsubunder.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                </template>
                                                </v-list-group>
                                                <v-list-tile v-else :key="i" :to="{ name: gsub.to }" >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsub.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
    
                                            </template>
                                        </v-list-group>
                                        <!--child item-->
                                        <!--Yeni Satış Menü -->
                                        <v-list-tile v-else :key="i" :to="{ name: grand.to }" >
                                        <!-- <v-list-tile v-else :key="i" :to="{ name: grand.to ,params: {id: grand.params }}"> -->
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ grand.title }} </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list-group>
    
                                <!--child item-->
                                <v-list-tile v-else :key="i" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple" :to="{name: subItem.to , params: {id: subItem.params }}" >
                           
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            <span>{{ subItem.title }} </span>
                                        </v-list-tile-title>
                                 
                                    </v-list-tile-content>
                                    <!-- yeni eski menu fark -->
                                    <!-- <v-list-tile-action ripple="ripple">
                                        <v-icon>{{ subItem.icon }} </v-icon> 
                                    </v-list-tile-action> -->
                                    <v-chip class="white--text pa-0 chip--x-small" v-if="subItem.badge" color="primary" disabled="disabled">{{
                                    subItem.badge }}</v-chip>
                                    <!-- <v-list-tile-action v-if="subItem.action">
                                        <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                    </v-list-tile-action> -->
                                </v-list-tile>
                            </template>
                        </v-list-group>
    
                        <v-list-tile v-else :key="item.title" :to="!item.href ? { name: item.to } : null" :href="item.href" >
                            <v-list-tile-action>
                                <v-icon>{{ item.icon }} </v-icon> 
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.title }} 
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <!-- yeni menude burasi items25 olacak -->
                       
    
                    </template>
                </v-list>
            </v-navigation-drawer>
        
            <v-navigation-drawer v-if="this.nextMuhasebe==true"   persistent :mini-variant="miniVariant" width="245" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed="" app>
                <v-list dense>
                    <template   v-for="item in items2" > 
                        <v-list-group v-if="item.items" :key="item.title" :prepend-icon="item.icon"  no-action>
                            <v-list-tile slot="activator">
                                <v-list-tile-content>
                                    <v-list-tile-title> {{ item.title }} </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <template v-for="(subItem, i) in item.items">
                                <!--sub group-->
                                <v-list-group v-if="subItem.items" :group="subItem.group" :sub-group="true" :key="subItem.title" >
                                    <v-list-tile slot="activator" ripple="ripple">
                                        <v-list-tile-content>
                                         <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                        </v-list-tile-content>
                                          <v-list-tile-action ripple="ripple">
                                            <v-icon>{{ subItem.icon }} </v-icon> 
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <template v-for="(grand, i) in subItem.items" ripple="ripple">
                                        <v-list-group v-if="grand.items" :group="grand.group" :sub-group="true" :key="grand.title">
                                            <v-list-tile slot="activator" ripple="ripple">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ grand.title }} </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <template v-for="(gsub, i) in grand.items" ripple="ripple">
                                              <v-list-group v-if="gsub.items" :group="gsub.group" :sub-group="true" :key="gsub.title" >
                                                <!-- Yeni satış menu-->
                                            <v-list-tile slot="activator" ripple="ripple">
                                               <!-- <v-list-tile :key="i" :to="{ name: gsub.to }">  -->
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsub.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <template v-for="(gsubunder,q) in gsub.items" ripple="ripple" >
                                                  <v-list-tile :key="q" :to="{ name: gsubunder.to }">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsubunder.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                </template>
                                                </v-list-group>
                                                <v-list-tile v-else :key="i" :to="{ name: gsub.to }" >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ gsub.title }} </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
    
                                            </template>
                                        </v-list-group>
                                        <!--child item-->
                                        <!--Yeni Satış Menü -->
                                        <v-list-tile v-else :key="i" :to="{ name: grand.to }" >
                                        <!-- <v-list-tile v-else :key="i" :to="{ name: grand.to ,params: {id: grand.params }}"> -->
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ grand.title }} </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list-group>
    
                                <!--child item-->
                                <v-list-tile v-else :key="i" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple" :to="{name: subItem.to , params: {id: subItem.params }}" >
                           
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            <span>{{ subItem.title }} </span>
                                        </v-list-tile-title>
                                 
                                    </v-list-tile-content>
                                    <!-- yeni eski menu fark -->
                                    <!-- <v-list-tile-action ripple="ripple">
                                        <v-icon>{{ subItem.icon }} </v-icon> 
                                    </v-list-tile-action> -->
                                    <v-chip class="white--text pa-0 chip--x-small" v-if="subItem.badge" color="primary" disabled="disabled">{{
                                    subItem.badge }}</v-chip>
                                    <!-- <v-list-tile-action v-if="subItem.action">
                                        <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                    </v-list-tile-action> -->
                                </v-list-tile>
                            </template>
                        </v-list-group>
    
                        <v-list-tile v-else :key="item.title" :to="!item.href ? { name: item.to } : null" :href="item.href" >
                            <v-list-tile-action>
                                <v-icon>{{ item.icon }} </v-icon> 
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.title }} 
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <!-- yeni menude burasi items25 olacak -->
                       
    
                    </template>
                </v-list>
            </v-navigation-drawer>
        
          
    
            <v-toolbar app :clipped-left="clipped" fixed dense>
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
           
                <a href="#/" class="d-flex ml-3 router-link-active">
                    <img src="./assets/images/arkman_nav.png">
                </a>
                <v-spacer></v-spacer>
               
                <div class="font-weight-light title mb-1">
              <h6> {{ $t('Membership-Termination-Date') }} : ( {{this.uyelikBitisi | dateformat}} )</h6>  
                </div>
              
                <v-spacer></v-spacer>
               
    
    
                
    
                <v-toolbar-items>
    
                    <v-menu v-if="sayfaCheck($route.name) == 2" hide-details bottom left offset-y>
                        <v-btn @click="sirketgetir()" flat slot="activator">
                            <span>{{ Sirket.SirketAdi }}</span>
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile v-for="item in Sirketler1" :key="item.text" @click="sirketdegistir(item,1)">
                                <v-list-tile-title>{{ item.SirketAdi }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
    
                    <v-menu v-if="sayfaCheck($route.name) == 0" hide-details bottom left offset-y>
                        <v-btn flat slot="activator">
                            <span>{{CoperSirketAdi}}</span>
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile v-for="item in CoperSirketler" :key="item.text" @click="copersirketdegistir(item,2)">
                                <v-list-tile-title>{{ item.SirketKod }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
    
                    <v-menu v-if="sayfaCheck($route.name) == 1" hide-details bottom left offset-y>
                        <v-btn flat slot="activator">
                            <span> {{ '( ' }} {{ MuhasebeSirketNo }} {{ ') ' }} {{MuhasebeSirketAdi}}</span>
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile  v-for="item in MuhasebeSirketler" v-if="item.CompanyID!=MuhasebeSirketNo" :key="item.text" @click="muhasebesirketdegistir(item,3)">
                                <v-list-tile-title >{{ '( ' }} {{ item.CompanyID }} {{ ') ' }} {{ item.CompanyShortName }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
    
                    
                    <v-menu :close-on-content-click="false" max-width="350px" bottom left offset-y>
                        <v-btn slot="activator" dark icon>
                            <v-badge class="top: -1px; right: 0px; " color="red" overlap>
                                <template v-slot:badge>
                                    <span>2</span>
                                </template>
                                <v-icon medium color="grey">notifications_active</v-icon>
                            </v-badge>
                        </v-btn>
                        <v-card>
                            <v-list>
    
                                <v-list-tile>
    
                                    <v-list-tile-title>
                                        <v-layout align-center justify-start fill-heigth>
                                            <v-icon>notifications
                                            </v-icon> &nbsp; Bildirimler
                                        </v-layout>
    
                                    </v-list-tile-title>
    
                                </v-list-tile>
    
                            </v-list>
                            <v-divider></v-divider>
                            <v-list>
                                <v-list-tile @click="borcluListesi()">
                                    <v-list-tile-title> <span class="grey-text body-1"> {{$t('To-see-your-debtor-creditor-list-click here') }}
                                            </span></v-list-tile-title>
                                </v-list-tile>
    
                                <v-list-tile @click="getLink()">
                                    <v-chip small color="green" text-color="white">
                                        {{ $t('New') }}
                                    </v-chip> <span class="grey-text body-1">{{$t('Click-for-customer-report-link')}} </span>
                                </v-list-tile>
    
                            </v-list>
                        </v-card>
    
                    </v-menu>
    
                    <!--
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon large color="grey">notifications</v-icon>
                </v-btn>
                <v-list>
    
                  <v-list-tile @click="borcluListesi()">
                    <v-list-tile-title>Borçlu Alacaklı Listesi </v-list-tile-title>
                  </v-list-tile>
    
                </v-list>
              </v-menu> -->
    
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="100" bottom left offset-y>
                        <template slot="activator">
                            <v-avatar size="26px">
                                <img src="https://randomuser.me/api/portraits/lego/2.jpg">
                            </v-avatar>
    
                        </template>
    
                        <v-card>
                            <v-list>
                                <v-card flat color="grey lighten-4">
                                    <v-list-tile @click="kullaniciyagit()">
                                        <v-list-tile-action>
                                            <v-icon>settings
                                            </v-icon>
    
                                        </v-list-tile-action>
                                        <v-list-tile-title>{{aktifkullanici}}</v-list-tile-title>
                                    </v-list-tile>
                                </v-card>
                            </v-list>
    
                            <v-divider></v-divider>
    
                            <v-list>
    
                                <v-list-tile @click="anasirketleregit()">
                                    <v-list-tile-action>
                                        <v-icon>account_balance_wallet
                                        </v-icon>
    
                                    </v-list-tile-action>
                                    <v-list-tile-title>{{ $t('Main-Companies') }}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="urunDetayAc()">
                                    <v-list-tile-action>
                                        <v-icon>
                                            card_membership
                                        </v-icon>                                
                                    </v-list-tile-action>
                                    <v-list-tile-title>{{ $t('Membership-information')}} </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="yardimciIslemAc()">
                                    <v-list-tile-action>
                                        <v-icon>
                                            cached
                                        </v-icon>                                
                                    </v-list-tile-action>
                                    <v-list-tile-title> {{ $t('Edit-Taxes')}}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>language</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-sub-title>
                                        <v-layout justify-center align-start="">
                                            <v-select solo :items="locales" hide-details="" v-model="locale" item-text="title" @change="changeLanguage(locale)" item-value="locale"></v-select>
                                        </v-layout>
    
                                    </v-list-tile-sub-title>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile @click="logout()">
                                    <v-list-tile-action>
                                        <v-icon>power_settings_new</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title> &nbsp;{{$t('Log-Out')}}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
    
                        </v-card>
                    </v-menu>
    
                </v-toolbar-items>
    
            </v-toolbar>
            <v-content>
    
                <router-view></router-view>
    
            </v-content>
    
            <v-btn small fab color="green" bottom right fixed @click="dialogMesajAc()">
                <v-icon color="white">chat</v-icon>
            </v-btn>
    
            <!-- <v-speed-dial small v-model="fab" :top="false" :bottom="true" :right="true" :left="false" fixed direction="top"
            :transition="'scala-transition'">
            <template v-slot:activator>
              <v-btn small v-model="fab" color="green" dark fab>
                <v-icon>chat</v-icon>
                <v-icon>close</v-icon>
              </v-btn>
            </template>
    
          </v-speed-dial> -->
    
            <!--
          <v-snackbar height="500px;" style="height:400px !important;padding-bottom:25px;padding-right:20px;"
            v-model="snackbarmesaj" :bottom="true" :left="false" :multi-line="true" :right="true" :timeout="timeout"
            :top="false" :vertical="true">
            Mesaj Gönder
            <v-card height="%100">
              <v-textarea rows="10" label="Mesajınız" id="textalan" name="textalan" hide-details=""></v-textarea>
            </v-card>
            <v-btn dark text @click="snackbar1 = false">
              Close
            </v-btn>
          </v-snackbar> -->
    
            <v-footer :fixed="fixed" app>
                <span>&copy; 2018 ARKMAN &mdash; {{ this.Sirket.SirketUnvani }} <span class="font-weight-light black--text caption "> Arkman </span> <a @click="gizlilikSozlesme()" style="cursor: pointer;" class="font-weight-light info--text caption "><span class="info--text">
                     {{ $t('Confidentiality') }}
                        </span> </a> <span class="font-weight-light black--text caption "> {{ $t('and') }} </span> <a @click="aydinlatmaSozlesme()" style="cursor: pointer;" class="font-weight-light info--text caption"><span class="info--text">  {{ $t('Clarification-Text') }} </span></a>
                    <span class="font-weight-light black--text caption ">   {{$t('For-Version-Information')}}</span><a @click="versiyonlarGonder()" style="cursor: pointer;" class="font-weight-light info--text caption"><span class="info--text"> {{$t('Please-Click')}}.</span></a></span>
                  
                    <v-spacer></v-spacer>
                    <span class="font-weight-light  caption "  style="padding-right: 56px;color:gray"> {{ 'Api Sürüm:'}}  {{  this.versiondate }}</span>
                  
                </v-footer>
    
            <v-dialog v-model="dialogMuhasebeUyari" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                    <v-card-text> Resmi Muhasebe Kullanımı İçin Yapılandırma Tamamlanmamış, ARKMAN Destek Biriminden Yardım Alabilirsiniz.</v-card-text>
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" flat="flat" @click.native="dialogMuhasebeUyari = false">{{$t("cancel_button")}}</v-btn>
                       
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                    <v-card-text v-if="islemtip==1"> Şirket değişimi yapmak istiyor musunuz?</v-card-text>
                    <v-card-text v-if="islemtip==2"> Coper Şirket değişimi yapmak istiyor musunuz?</v-card-text>
                    <v-card-text v-if="islemtip==3"> Muhasebe Şirket değişimi yapmak istiyor musunuz?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" flat="flat" @click.native="dialog = false">{{$t("cancel_button")}}</v-btn>
                        <v-btn v-if="islemtip==1" color="info" flat @click.native="degistir()">{{ $t('OK') }}</v-btn>
                        <v-btn v-if="islemtip==2" color="info" flat @click.native="coperdegistir()">{{ $t('OK') }}</v-btn>
                        <v-btn v-if="islemtip==3" color="info" flat @click.native="muhasebedegistir()">{{ $t('OK') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
    
            <v-dialog class="box" persistent v-model="dialogmesaj" width="400">
                <v-card color="white">
                    <v-card-text>
                        <v-layout v-if="MesajSonuc==null" pt-2 align-center="" fill-height="">
                            <v-icon color="grey">chat</v-icon> &nbsp;
                            <span class="subheading"> Hata / Öneri Bildir</span>
                        </v-layout>
    
                        <v-layout v-if="MesajSonuc!=null" pt-2 align-center="" fill-height="">
                            <v-icon color="red">info</v-icon> &nbsp;
                            <span class="grey--text subheading"> {{MesajSonuc}}</span>
                        </v-layout>
                        <v-form ref="formmesaj" v-model="validmesaj" lazy-validation>
                            <v-layout row wrap>
                                <!-- <v-flex xs12 md12 sm12>
                      <v-text-field label="Telefon No">
                      </v-text-field>
                    </v-flex> -->
                                <v-flex xs12 md12 sm12>
                                    <v-text-field v-if="MesajSonuc==null" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="MesajAd" label="Ad Soyad">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md12 sm12>
                                    <v-text-field v-if="MesajSonuc==null" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="MesajTel" label="Telefon">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md12 sm12>
                                    <v-textarea v-if="MesajSonuc==null" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="MesajAciklama" rows="10" no-resize label="Mesajınız">
                                    </v-textarea>
                                </v-flex>
                                <!-- <v-flex v-if="MesajSonuc!=null" xs12 md12 sm12>
                      <span class="red--text ">{{MesajSonuc}}</span>
                    </v-flex> -->
    
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" flat @click.native="dialogmesaj=false">{{$t('Close')}}</v-btn>
                        <v-btn color="info" v-if="MesajSonuc==null" flat @click="mesajGonder()">{{ $t('Send') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-dialog v-model="dialogoturum" persistent width="500">
                <v-card color="primary" dark>
                    <v-card-text>
                        <v-layout pt-2 align-center="" fill-height="">
                            <v-icon large color="white">notification_important</v-icon> &nbsp;
                            <span class="subheading"> {{$t('Your-session-has-ended,-please-log-in.')}}</span>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="white" flat @click="logout()"> {{ $t('Login-v2') }} </v-btn>
    
                    </v-card-actions>
                </v-card>
            </v-dialog>
           
            <v-snackbar :timeout="timeoutlogin" :top="ylogin === 'top'" :bottom="ylogin === 'bottom'" :right="xlogin === 'right'" :left="xlogin === 'left'" :multi-line="modelogin === 'multi-line'" :vertical="true" v-model="snackbarlogin">
                <v-layout align-center fill-height>
                    <v-icon large color="pink">notification_important</v-icon> &nbsp; {{ text1login }}
                </v-layout>
                <v-layout justify-end align-start mb-2>
                    <v-btn flat color="pink" @click="logout()"> {{ $t('Login-v2') }} </v-btn>
                </v-layout>
            </v-snackbar>
    
    
    
        </div>
    </v-app>
    </template>
    
    <script>
    import TheLanguageSwitcher from '@/components/TheLanguageSwitcher'
    import helpers from "@/components/app/customcomp/helpers.js"
    import tool from "./components/app/coper/tools";
    import axios from 'axios'
    import auth from './api/auth'
    import router from './router'
    import _ from 'underscore'
    import $ from '@/plugins/i18n.js'
    import {
        Trans
    } from '@/plugins/Translation'
    
    import VeHistogram from 'v-charts/lib/histogram.common'
    import jwtDecode from 'jwt-decode/build/jwt-decode.min.js'
    import gizlilikSozlesme from "@/components/app/customcomp/kvkksozlesme.vue"
    import aydinlatmaSozlesme from "@/components/app/customcomp/aydinlatmasozlesme.vue"
    import musteriraporlink from "@/components/app/customcomp/musteriraporlink.vue"
    import kontorlerDialog from "@/components/app/account/kontorDurum.vue"
    import yardimciIslemDialog from "@/components/app/account/yardimciIslemDialog.vue"
    export default {
    
        data() {
            return {
                versiondate:'',
                PB:"TRY",
                nextMuhasebe:false,
                dialogMuhasebeUyari:false,
                uyelikBitisi:'',
                MesajSonuc: null,
                MesajAciklama: null,
                MesajAd: null,
                MesajTel: null,
                validmesaj: true,
                dialogmesaj: false,
                YeniMuhasebeSirketNo:null,
                YeniMuhasebeSirketUnvani:null,
                YeniMuhasebeSirketAdi:null,
                YeniCoperSirketAdi: null,
                YeniCoperSirketNo: null,
                YeniCoperSirketUnvani: null,
                dialogoturum: false,
                timeout: 6000,
                snackbar: false,
                snackbarmesaj: true,
                y: 'top',
                x: 'right',
                mode: '',
                text1: '',
                
                snackbarlogin: false,
                ylogin: 'top',
                xlogin: 'right',
                modelogin: '',
                timeoutlogin: 0,
                text1login: 'Oturum süreniz dolmuştur, yeniden giriş yapmalısınız.',
                islemtip: 1,
    
                aktifkullanici: null,
                on: false,
                fav: true,
                menu: false,
                message: false,
                hints: true,
                locale: 'tr',
                //locale: localStorage.getItem("lang"),
                locales: [{
                        locale: 'tr',
                        title: 'Türkçe',
                        href: 'turkey'
                    },
                    {
                        locale: 'en',
                        title: 'English',
                        href: 'english'
                    },
                    {
                        locale: 'de',
                        title: 'Deutsch',
                        href: 'germany'
                    },
                    {
                        locale: 'fr',
                        title: 'French',
                        href: 'france'
                    },
                    {
                        locale: 'deC',
                        title: 'Deutsch-C+',
                        href: 'germany'
                    },
                ],
                fab: false,
                clipped: true,
                drawer: true,
                fixed: false,
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'Arkman',
              
              

                items: [{
                        icon: 'home',
                        title: this.$t('mainpage_menu'),
                        to: 'home',
                        href: '/#/'
                    },
                    {
                        icon: 'today',
                        title: this.$t('Calendar'),
                        to: 'takvim',
                        href: '/#/takvim/takvim'
                    },
                    {
                        icon: 'attach_money',
                        title: this.$t('Current-Account'),
                        group: 'cari',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('current_index_header'),
                                to: 'cari-index',
                                href: '/#/cari/index'
                            },
                            {
                                title: this.$t('Current-Movements'),  
                                to: 'carihareketler-index',
                                href: '/#/carihareketler/index'
                            },
                            {
                                title: this.$t('Bank-transactions'),
                                group: 'banka',
                                namespace: 'banka',
                                items: [{
                                        title: this.$t('Bank-transactions'),
                                        to: 'bankaentegrasyonu-online-banka-hareketleri',
                                        href: '/#/bankaentegrasyonu/bankahareketleri'
                                    },
                                ],
                            },
                            {
                                title: this.$t('Extract'),
                                group: 'ekstreler',
                                namespace: 'cari',
                                items: [{
                                        title: this.$t('Extract-of-Account'),
                                        to: 'ekstre-hesap',
                                        href: '/#/ekstreler/hesabagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Date'),
                                        to: 'ekstre-tarih',
                                        href: '/#/ekstreler/tarihegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Reference'),
                                        to: 'ekstre-referans',
                                        href: '/#/ekstreler/referansagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Expence-Center'),
                                        to: 'ekstre-masraf',
                                        href: '/#/ekstreler/masrafmerkezinegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Firm-Card'),
                                        to: 'ekstre-firmakart',
                                        href: '/#/ekstreler/firkakartinagore'
    
                                    },
                                ]
                            },
                            
                            {
                                title: this.$t('Trial-Balance'),
                                group: 'mizanlar',
                                namespace: 'mizan',
                                items: [{
                                        title: this.$t('Trial-Balance-of-Account'),
                                        to: 'mizan-carihesap',
                                        href: '/#/mizan/carihesap'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Currency'),
                                        to: 'mizan-doviz',
                                        href: '/#/mizan/doviz'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Expense-Center'),
                                        to: 'mizan-masrafmerkezi',
                                        href: '/#/mizan/masrafmerkezi'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Reference'),
                                        to: 'mizan-referans',
                                        href: '/#/mizan/referans'
                                    }
                                ],
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'diger',
                                items: [
                                   
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'carigenelamaclirapor',
                                        href: '/#/diger/carigenelamaclirapor'
                                    },
    
                                    {
                                        title: this.$t('Debtor-and-Creditor-List'),
                                        to: 'borclu-liste',
                                        href: '#/diger/borclulistesi'
                                    }, {
                                        title: this.$t('Aging-Report'),
                                        to: 'yaslandirmaicmali',
                                        href: '#/diger/yaslandirmaicmali'
                                    },
                                    {
                                        title: this.$t('Cash-Report'),
                                        to: 'kasa-liste',
                                        href: '#/diger/kasaraporu'
                                    },
                                    {
                                        title: 'BA - BS Formu',
                                        group: 'babsform',
                                        items: [{
                                                title: 'BS Formu',
                                                to: 'bsformu',
                                                href: '/#/diger/bsformu'
                                            },
                                            {
                                                title: 'BA Formu',
                                                to: 'baformu',
                                                href: '/#/diger/baformu'
                                            },
                                            {
                                                title: this.$t('Statement-of-Reconciliation'),
                                                to: 'mutabakat-mektubu',
                                                href: '#/diger/mutabakatmektubu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Turnover-Reports'),
                                        group: 'ciroraporu1',
                                        items: [{
                                                title: this.$t('Turnover-Report'),
                                                to: 'ciroraporu',
                                                href: '#/diger/ciroraporu'
                                            },
                                            {
                                                title: this.$t('Turnover-Analysis-Report'),
                                                to: 'ciroanaliz',
                                                href: '#/diger/ciroanaliz'
                                            },
                                            {
                                                title: this.$t('Turnover-Profit-Analysis-Report'),
                                                to: 'cirokaranalizi',
                                                href: '#/diger/cirokaranalizi'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Pos-Reports'),
                                        group: 'pos',
                                        items: [{
                                                title: this.$t('Bank-POS-Statement'),
                                                to: 'bankaposekstresi',
                                                href: '#/diger/bankaposekstresi'
                                            },
                                            {
                                                title: this.$t('POS-Cost-Report'),
                                                to: 'posmaliyet',
                                                href: '#/diger/posmaliyetraporu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Customer-Profitability-Reports'),
                                        group: 'musterikarlilik',
                                        items: [{
                                            title: this.$t('Customer-Profitability-Report'),
                                            to: 'musterikarlilik',
                                            href: '#/diger/musterikarlilikraporu'
                                        }, {
                                            title: this.$t('Cust-Pro-Report'),
                                            to: 'musterikarlilikodeme',
                                            href: '#/diger/musterikarlilikodeme'
                                        }]
                                    }
                                ]
                            },
    
                            {
                                title: this.$t('Definitions'),
                                grup: 'genelparametre',
                                items: [{
                                        title: this.$t('General-Current-Account'),
                                        to: 'parametre-genel',
                                        href: '#/tanimlamalar/genel'
                                    },
                                    {
                                        title: this.$t('Company-Parameters'),
                                        to: 'parametre-sirket',
                                        href: '#/tanimlamalar/sirket'
                                    }
                                ]
                            },
                            {
                                title: this.$t('Extras'),
                                grup: 'ekstralar',
                                items: [{
                                    title: this.$t('Customer-Personnel-Entry'),
                                    to: 'ekstra-musteri',
                                    href: '#/ekstralar/musteri-personel'
                                }, {
                                    title: this.$t('Profile-Template-Design'),
                                    to: 'ekstralar-profilsablon',
                                    href: '#/ekstralar/profilsablon'
                                }, {
                                    title: this.$t('Template-Data-Entry'),
                                    to: 'ekstralar-verigirisi',
                                    href: '#/ekstralar/sablonverigirisi'
                                }]
                            }, {
                                title: this.$t('Definitions-v2'),
                                to: 'genelparametreler',
                                href: '/#/parametreler/genel'
                            },
                            {
                                title: this.$t('Auxiliaries'),
                                to: 'yardimci-islemler',
                                href: '/#/yardimciislemler/index'
                            },
                            {
                                title: this.$t('Exchange-Entry'),
                                to: 'kurgirisi',
                                href: '/#/cari/kurgirisi'
                            }
                        ]
    
                    },
                    {
                        icon: 'flight_takeoff',
                        title: this.$t('Ticket'),
                        group: 'bilet',
                        color: 'blue darken-2',
                        items: [
                            {
                                title: this.$t('Ticket-List'),
                                to: 'bilet-listesi',
                                href: '/#/bilet/index'
                            }, 
                            // {
                            //     title: 'Bilet Alış Fatura Entegrasyonu',
                            //     to: 'bilet-alis-entegre',
                            //     href: '/#/bilet/indexIntegrate'
                            // }, 
                            {
                                title: this.$t('Void-List'),
                                to: 'void-listesi',
                                href: '/#/bilet/voidlistesi'
                            }, {
                                title: this.$t('Refund-List'),
                                to: 'iade-listesi',
                                href: '/#/bilet/iadelistesi'
                            }, {
                                title: this.$t('Reports'),
                                to: 'bilet-raporlar',
                                items: [
                                   
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'genelamaclirapor',
                                        href: '/#/bilet/genelamaclirapor'
                                    },
                                    {
                                        title: this.$t('Daily-Sales-Report'),
                                        to: 'bilet-gunluksatisraporu',
                                        href: '/#/bilet/gunluksatisraporu'
                                    }, {
                                        title: this.$t('Sales-Distribution'),
                                        to: 'bilet-satisdagilimi',
                                        href: '/#/bilet/satisdagilimi'
                                    }, {
                                        title: this.$t('Customer-Turnover-and-Discount-Statistics'),
                                        to: 'bilet-mustericiroveiskonto',
                                        href: '/#/bilet/mustericiroveiskonto'
                                    },
                                    {
                                        title: this.$t('Income-Distribution-Report'),
                                        to: 'bilet-gelirdagilimiraporu',
                                        href: '/#/bilet/gelirdagilimiraporu'
                                    }, {
                                        title: this.$t('Performance-Analysis-Agent'),
                                        to: 'bilet-kesenkisianaliz',
                                        href: '/#/bilet/kesenkisianaliz'
                                    }, {
                                        title: this.$t('Return-Ticket-Invoice-Control'),
                                        to: 'bilet-iadebiletfatura',
                                        href: '/#/bilet/raporlar/iadebiletfatura'
                                    },
                                    {
                                        title: this.$t('Analysis-Report'),
                                        to: 'bilet-analizraporu',
                                        href: '/#/bilet/analizraporu'
                                    },
                                    {
                                        title: this.$t('Comparative-Customer-Monitoring-Report'),
                                        to: 'bilet-mukayeselirapor',
                                        href: '/#/bilet/mukayeselirapor'
                                    },
    
                                    {
                                        title: this.$t('Flight-Report'),
                                        to: 'bilet-ucusraporu',
                                        href: '/#/bilet/ucusraporu'
                                    },
    
                                    {
                                        title: this.$t('Periodic-Reports'),
                                        grup: 'devre-reporları',
    
                                        items: [{
                                                title: 'TK '+ this.$t('Periodic-Report'),
                                                to: 'bilet-tkdevreraporu',
                                                href: '/#/bilet/raporlar/tkdevreraporu'
                                            },
                                            {
                                                title: this.$t('General-Periodic-Report'),
                                                to: 'bilet-geneldevreraporu',
                                                href: '/#/bilet/raporlar/geneldevreraporu'
                                            },
                                            {
                                                title: 'Non IATA ' + this.$t('Periodic-Report'),
                                                to: 'bilet-noniatadevreraporu',
                                                href: '/#/bilet/raporlar/noniatadevreraporu'
                                            },
                                            {
                                                title: 'BSP ' + this.$t('Periodic-Report'),
                                                to: 'bilet-bspdevreraporu',
                                                href: '/#/bilet/raporlar/bspdevreraporu'
                                            }
                                        ]
                                    },
                                     {
                                        title: "Diğer Raporlar",
                                        grup: 'diger-reporları',
    
                                        items: [{
                                                title: 'Borusan Raporu',
                                                to: 'bilet-diger-borusan',
                                                href: '/#/bilet/raporlar/digerraporlar/tkdevreraporu'
                                            },
                                           
                                        ]
                                    }
                                ]
                            }, {
                                title: this.$t('Ticket-Transfers'),
                                to: 'bilet-aktarimlar',
                                items: [{
                                        title: 'THY ' + this.$t('Transfer'),
                                        to: 'thy-aktarim',
                                        href: '/#/bilet/aktarimbilet/thyaktarim'
                                    },
                                    {
                                        title: 'Juniper ' + this.$t('Transfer'),
                                        to: 'juniper-aktarim',
                                        href: '/#/bilet/aktarimbilet/juniperaktarim'
                                    },
                                    {
                                        title: 'AMADEUS ' + this.$t('Transfer'),
                                        to: 'amadeus-aktarim',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarim'
                                    }, {
                                        title: 'AMADEUS ' + this.$t('Transfer') + '(SFTP)',
                                        to: 'amadeus-aktarimftp',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarimftp'
                                    },{
                                        title: 'PEGASUS ' + this.$t('Transfer'),
                                        to: 'pegasusaktar',
                                        href: '/#/bilet/aktarimbilet/pegasusaktarim'
                                    }, 
                                    {
                                    title: 'PEGASUS Online Aktarım',
                                    to: 'pegasusonlineaktar',
                                    href: '/#/bilet/aktarimbilet/pegasusonlineaktarim'
                                }, 
                                    {
                                        title: 'AJET Excel ' + this.$t('Transfer'),
                                        to: 'ajetaktar',
                                        href: '/#/bilet/aktarimbilet/ajetaktarim'
                                    }, 
                                    {
                                        title: 'AJET Xml ' + this.$t('Transfer'),
                                        to: 'ajetaktarimxml',
                                        href: '/#/bilet/aktarimbilet/ajetaktarimxml'
                                    }, 
                                    {
                                        title: 'ONUR AIR ' + this.$t('Transfer'),
                                        to: 'onurairaktar',
                                        href: '/#/bilet/aktarimbilet/onurairaktar'
                                    }, {
                                        title: 'IATI ' + this.$t('Transfer'),
                                        to: 'iatiaktar',
                                        href: '/#/bilet/aktarimbilet/iatiaktar'
                                    }, {
                                        title: 'SUNEXPRESS ' + this.$t('Transfer'),
                                        to: 'sunexpressaktar',
                                        href: '/#/bilet/aktarimbilet/sunexpressaktar'
                                    }, {
                                        title: 'GALILEO ' + this.$t('Transfer'),
                                        to: 'galileoaktar',
                                        href: '/#/bilet/aktarimbilet/galileoaktar'
                                    }, {
                                        title: 'SABRE ' + this.$t('Transfer'),
                                        to: 'sabreaktar',
                                        href: '/#/bilet/aktarimbilet/sabreaktar'
                                    }, {
                                        title: 'BOOKING AGORA ' + this.$t('Transfer'),
                                        to: 'bookingagoraaktar',
                                        href: '/#/bilet/aktarimbilet/bookingagoraaktar'
                                    },
                                    {
                                        title: 'FLY KHY ' + this.$t('Transfer'),
                                        to: 'lydiaaktar',
                                        href: '/#/bilet/aktarimbilet/lydiaaktar'
                                    },
                                    {
                                        title: 'ATLAS ' + this.$t('Transfer'),
                                        to: 'atlasaktar',
                                        href: '/#/bilet/aktarimbilet/atlasaktar'
                                    },
                                    {
                                        title: 'BIZITRAVEL ' + this.$t('Transfer'),
                                        to: 'bizitravelaktar',
                                        href: '/#/bilet/aktarimbilet/bizitravelaktar'
                                    },
                                    {
                                        title: 'BILETBANK ' + this.$t('Transfer'),
                                        to: 'biletbankaktar',
                                        href: '/#/bilet/aktarimbilet/biletbankaktar'
                                    },
                                    {
                                        title: 'BILETALL ' + this.$t('Transfer'),
                                        to: 'biletallaktar',
                                        href: '/#/bilet/aktarimbilet/biletallaktar'
                                    },
                                    {
                                        title: 'Turkmen Air ' + this.$t('Transfer'),
                                        to: 'turkmanairaktar',
                                        href: '/#/bilet/aktarimbilet/turkmanairaktar'
                                    },
                                    {
                                        title: 'THY XML ' + this.$t('Transfer'),
                                        to: 'thy-aktarim-xml',
                                        href: '/#/bilet/biletaktarim/thyaktarimxml'
                                    },
                                    {
                                        title: 'Arkman ' + this.$t('Transfer'),
                                        group: 'arkmanaktarim',
                                        items: [{
                                                title: 'XML ' + this.$t('Transfer'),
                                                to: 'arkmanxmlaktar',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlaktar'
                                            }, {
                                                title: 'Arkman XML Export',
                                                to: 'arkmanxmlexport',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlexport'
                                            },
                                            {
                                                title: 'EXCEL ' + this.$t('Transfer'),
                                                to: 'excelaktar',
                                                href: '/#/bilet/aktarimbilet/excelaktar'
                                            }
                                        ]
                                    }
    
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'bilet-tanimlamalar',
                                href: '/#/bilet/tanimlamalar'
                            }
                        ]
                    },
    
                    //  Coper başla
                    {
                        icon: 'hotel',
                        title: 'Coper ',
                        group: 'coper',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Booking-List'),
                                to: 'coper-rezervasyonlistesiGuncel',
                                href: '/#/coper/rezervasyon/rezervasyonlistesi'
                            },
                            {
                                title: this.$t('Sellers'),
                                group: 'saticilar',
                                items: [{
                                    title: this.$t('Hotel-List'),
                                    to: 'coper-otel-listesi',
                                    href: '/#/coper/otel/index'
                                }, {
                                    title: 'Transfer',
                                    to: 'coper-transfer-listesi',
                                    href: '/#/coper/transfer/index'
                                }, {
                                    title: 'Restaurant',
                                    to: 'coper-restaurant-listesi',
                                    href: '/#/coper/restaurant/index'
                                }, {
                                    title: this.$t('Agency'),
                                    to: 'coper-acente-listesi',
                                    href: '/#/coper/acente/index'
                                }, {
                                    title: this.$t('Rent-A-Car'),
                                    to: 'coper-rentacar-listesi',
                                    href: '/#/coper/rentacar/index'
                                }, {
                                    title: this.$t('Guide'),
                                    to: 'coper-rehber-listesi',
                                    href: '/#/coper/rehber/index'
                                }, {
                                    title: this.$t('Museum'),
                                    to: 'coper-muze-listesi',
                                    href: '/#/coper/muze/index'
                                }, {
                                    title: this.$t('Charter'),
                                    to: 'coper-charter-listesi',
                                    href: '/#/coper/charter/index'
                                }, {
                                    title: this.$t('Cruise'),
                                    to: 'coper-gemi-listesi',
                                    href: '/#/coper/gemi/index'
                                }, {
                                    title: this.$t('Other'),
                                    to: 'coper-diger-listesi',
                                    href: '/#/coper/diger/index'
                                }, {
                                    title: this.$t('Visa'),
                                    to: 'coper-vize-listesi',
                                    href: '/#/coper/vize/index'
                                }, {
                                    title: this.$t('Tour-Operator'),
                                    to: 'coper-turoperator-listesi',
                                    href: '/#/coper/turoperator/index'
                                }, {
                                    title: this.$t('Insurance'),
                                    to: 'coper-sigorta-listesi',
                                    href: '/#/coper/sigorta/index'
                                }, {
                                    title: this.$t('Ferry'),
                                    to: 'coper-feribot-listesi',
                                    href: '/#/coper/feribot/index'
                                }, {
                                    title: 'Golf',
                                    to: 'coper-golf-listesi',
                                    href: '/#/coper/golf/index'
                                }]
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'coperraporlar',
                                items: [{
                                    title: this.$t('Sales-Report'),
                                    to: 'coper-satisraporu',
                                    href: '/#/coper/raporlar/satisraporu'
                                },{
                                    title: this.$t('General-Purpose-Report'),
                                    to: 'coper-genelamaclirapor',
                                    href: '/#/coper/raporlar/genelamaclirapor'
                                }, {
                                    title: this.$t('Profitability-Report'),
                                    to: 'coper-karlilikraporu',
                                    href: '/#/coper/raporlar/karlilikraporu'
                                }, {
                                    title: this.$t('Seller-Payment-Report'),
                                    to: 'coper-odemeraporu',
                                    href: '/#/coper/raporlar/odemeraporu'
                                },{
                                    title: this.$t('Invoices-Received-Not-Received'),
                                    to: 'coper-faturasigelengelmeyenraporu',
                                    href: '/#/coper/raporlar/faturasigelengelmeyen'
                                },
                                {
                                    title: this.$t('Visa-Tracking-List'),
                                    to: 'coper-vizetakiplistesi',
                                    href: '/#/coper/raporlar/vizetakiplistesi'
                                }, 
                                {
                                    title: this.$t('Daily-Tour-List'),
                                    to: 'coper-gunluktur',
                                    href: '/#/coper/raporlar/gunlukturlistesi'
                                }, 
                                ]
                            },
                            {
                                
                                title: 'Coper ' + this.$t('Forms'),
                                group: 'faturaraporlar',
                                items: [ {
                                        title: this.$t('Quotation-Form'),
                                        to: 'coper-kotasyonformu',
                                        params:'islem=yeni',
                                        href: '/#/coper/page/formlar/kotasyonformu/id'
                                    }
                                ]
                            },
                            {
                                title: this.$t('Payments'),
                                group: 'coperodemeler',
                                items: [{
                                        title: this.$t('Seller-Payments'),
                                        to: 'coper-saticiodemeler',
                                        href: '/#/coper/odemeler/saticiodemelistesi'
                                    },
    
                                ]
                            },
                            {
                                title: this.$t('Advertisements'),
                                group: 'copertanitimlar',
                                items: [{
                                        title: this.$t('Definitions-v2'),
                                        to: 'coper-tanitimlar-parametrelist',
                                        href: '/#/coper/tanitimlar/parametreler'
                                    },
                                    {
                                        title: this.$t('Address_label'),
                                        to: 'coper-adreslistesi',
                                        href: '/#/coper/tanitimlar/adreslistesi'
                                    },
                                    {
                                        title: this.$t('Hotel-List'),
                                        to: 'coper-tanitimlar-otellistesi',
                                        href: '/#/coper/tanitimlar/Otellistesi/otellistesi'
                                    },
                                    {
                                        title: this.$t('Collection'),
                                        to: 'coper-odemelistesi',
                                        href: '/#/coper/tanitimlar/odeme'
                                    },
                                    {
                                        title: this.$t('Agency-Commission'),
                                        to: 'coper-tanitimlar-acentekomisyon',
                                        href: '/#/coper/tanitimlar/acentekomisyon'
                                    }, {
                                        title: this.$t('Profitability'),
                                        to: 'coper-tanitimlar-karlilik',
                                        href: '/#/coper/tanitimlar/karlilik'
                                    },
                                    {
                                        title: this.$t('Visa-Price'),
                                        to: 'coper-tanitimlar-vizefiyatlist',
                                        href: '/#/coper/tanitimlar/vizefiyat/index'
                                    },
                                    {
                                        title: this.$t('Hotel-Category'),
                                        to: 'coper-otelkategori',
                                        href: '/#/coper/tanitimlar/otelkategori'
                                    },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'coperaktarimlar',
                                items: [{
                                        title: 'Bizitravel',
                                        to: 'coper-aktarim-bizitravel',
                                        href: '/#/coper/aktarim/bizitravel'
                                    },
                                    {
                                        title: 'Booking Agora',
                                        to: 'coper-aktarim-bookingagora',
                                        href: '/#/coper/aktarim/bookingagora'
                                    },
                                    {
                                        title: 'Juniper',
                                        to: 'coper-aktarim-juniper',
                                        href: '/#/coper/aktarim/juniper'
                                    },
                                ]
                            },
                        ]
                    },
                        {
                        icon: 'inventory',
                        title: this.$t('Visa-Procedures'),
                        to: 'coper-vize-yeni',
                        href: '/#/coper/vize/yeni/id?islem=yeni'
                        },
                        {
                        icon: 'receipt',
                        title: this.$t('Bills'),
                        group: 'faturalar',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Sales-Invoice-List'),
                                to: 'faturalistesi',
                                href: '/#/fatura/faturalistesi'
                            }, {
                                title: this.$t('List-of-Invoices-Received'),
                                to: 'gelenfaturalistesi',
                                href: '/#/fatura/gelenfaturalistesi'
                            },
                            {
                                title: this.$t('Ticket-Self-invoice'),
                                to: 'fatura-basma',
                                href: '/#/fatura/faturabasma'
                            },
                             {
                                title: 'E-Fatura (BETA)',
                                group: 'coper-e-faturalar',
                                items: [ {
                                title: "Gelen Fatura Listesi",
                                to: 'fatura-EFaturaListesi',
                                href: '/#/fatura/gelenEFaturaListesi'
                                },{
                                title: this.$t('Save-Received-E-Invoices-Archive'),
                                to: 'fatura-EFaturalariHavuzaKaydet',
                                href: '/#/fatura/gelenEFaturalariHavuzaKaydet'
                                },{
                                title: this.$t('Invoice-Status-Query'),
                                to: 'faturasorgula',
                                href: '/#/fatura/faturadurumsorgula'
                                },
                                ]
                            },
                             {
                                title: 'Coper',
                                group: 'coperfaturalar',
                                items: [ {
                                title: this.$t('Bulk-Invoice'),
                                to: 'fatura-copertoplufaturalistesi',
                                href: '/#/fatura/copertoplufatura'
                                },{
                                title: this.$t('Invoice-Received'),
                                to: 'coper-gelenfaturalistesi',
                                href: '/#/coper/page/formlar/gelenfaturalistesi'
                                },{
                                title: this.$t('Commission-Invoice'),
                                to: 'coper-komisyonfaturasi',
                                href: '/#/coper/komisyonfaturasi/index'
                                }, {
                                title: this.$t('Sales-Return-Invoice-List'),
                                to: 'fatura-coper-satisiade',
                                href: '/#/fatura/copersatisiade'
                                },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'aktarimlar',
                                items: [{
                                    title: this.$t('Free-Invoice-Transfers'),
                                    to: 'fatura-aktarimlar-serbestfatura',
                                    href: '/#/fatura/aktarimlar/serbestfaturaexcel'
                                }, 
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'faturatanimlamalar',
                                href: '/#/fatura/tanimlamalar'
                            }, {
                                title: this.$t('Settings'),
                                to: 'faturaayarlar',
                                href: '/#/fatura/ayarlar'
                            },
                            // {
                            //     title: 'Satış Fatura Entegrasyonu',
                            //     to: 'faturaentegrasyon',
                            //     href: '/#/fatura/faturaentegrasyon'
                            // },

                        ]
    
                    },
                  {
                       icon: 'business',
                       title: this.$t('Market-Place-Beta'),
                       group: 'satis',
                       color: 'blue darken-2',
                       items: [   
                            {
                               icon:'hotel',
                               title: 'Hotel Runner',
                               group: 'runner',
                               items: [{
                               icon: 'maps_home_work',
                               title: this.$t('Hotel'),
                               to: 'satis-hotelrunner',
                               params: 'isl=hryeni',
                               href: '/#/hotelrunner/index',
                               },{
                               icon: 'maps_home_work',
                               title: this.$t('Hotel-List'),
                               to: 'satis-hotelrunner-list',
                               href: '/#/hotelrunner/oteltanitim/list',
                               }
                               ]
                           },
                           {
                               icon: 'directions_bus',
                               title: this.$t('Transfer-v4'),
                               to: 'satis-paxdrive',
                               params: 'islemTipi=pdyeni',
                               href: '/#/coper/paxdrive/index/id'
                           },
                           {
                               icon:'flight',
                               title: this.$t('Flight'),
                               group: 'ucus',
                               items: [{
                                   title: this.$t('Search-Flight'),
                                   to: 'satis-ucus-liste',
                                   href: '/#/satis/ucak/index'
                               }, {
                                   title: this.$t('Reservation-List'),
                                   to: 'satis-ucus-rezliste',
                                   href: '/#/satis/ucak/rezervasyonliste'
                               },
                               ]
                           },]
                   }, 
                //    {
                //        icon: 'undo',
                //       title: 'Paket Tur',
                //       group: 'pakettur',
                //        color: 'blue darken-2',
                //        items: [   
                           
                //            {
                //                icon: 'directions_bus',
                //                title: 'Master Paketler',
                //                to: 'masterpaket',
                //                href: '/#/pakettur/masterpaket'
                //            },
                          
                //         ]
                //    }, 
                    {
                        icon: 'explicit',
                        title: this.$t('Integration'),
                        to: 'entegrasyon-index',
                        href: '/#/entegrasyon/index'
                    },
                    {
                        icon: 'widgets',
                        title: this.$t('Additional-Products'),
                        to: 'ek-urunler',
                        href: '/#/urunler/ekurunler'
    
                    },
                    {
                        icon: 'cloud_download',
                        title: 'Next ' + this.$t('Upload-Ticket'),
                        color: 'blue darken-2',
                        to: 'download-page',
                        href: '/#/download/index'
                    },
                     {
                        icon: 'help',
                        title: this.$t('Help'),
                        to: 'yardim',
                        href: '/#/diger/yardim'
                    },
                ],
    
               
             
    
    
                items25: [
                    {
                        icon: 'home',
                        title: this.$t('mainpage_menu'),
                        to: 'home',
                        href: '/#/'
                    },
                    {
                        icon: 'today',
                        title: this.$t('Calendar'),
                        to: 'takvim',
                        href: '/#/takvim/takvim'
                    },
                    {
                        icon: 'account_balance',
                        title: this.$t('Accounting') ,
                        group: 'muhasebe',
                        color: 'blue darken-2',
                        items: [  {
                        icon: 'attach_money',
                        title: this.$t('Current-Account'),
                        group: 'cari',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('current_index_header'),
                                to: 'cari-index',
                                href: '/#/cari/index'
                            },
                            {
                                title: this.$t('Current-Movements'),  
                                to: 'carihareketler-index',
                                href: '/#/carihareketler/index'
                            },
                            {
                                title: this.$t('Extract') ,
                                group: 'ekstreler',
                                namespace: 'cari',
                                items: [{
                                        title: this.$t('Extract-of-Account'),
                                        to: 'ekstre-hesap',
                                        href: '/#/ekstreler/hesabagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Date'),
                                        to: 'ekstre-tarih',
                                        href: '/#/ekstreler/tarihegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Reference'),
                                        to: 'ekstre-referans',
                                        href: '/#/ekstreler/referansagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Expence-Center'),
                                        to: 'ekstre-masraf',
                                        href: '/#/ekstreler/masrafmerkezinegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Firm-Card'),
                                        to: 'ekstre-firmakart',
                                        href: '/#/ekstreler/firkakartinagore'
    
                                    },
                                ]
                            },
                            {
                                title: this.$t('Trial-Balance'),
                                group: 'mizanlar',
                                namespace: 'mizan',
                                items: [{
                                        title: this.$t('Trial-Balance-of-Account'),
                                        to: 'mizan-carihesap',
                                        href: '/#/mizan/carihesap'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Currency'),
                                        to: 'mizan-doviz',
                                        href: '/#/mizan/doviz'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Expense-Center'),
                                        to: 'mizan-masrafmerkezi',
                                        href: '/#/mizan/masrafmerkezi'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Reference'),
                                        to: 'mizan-referans',
                                        href: '/#/mizan/referans'
                                    }
                                ],
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'diger',
                                items: [
                                    // {
                                    //   title: this.$t('General-Purpose-Report'),
                                    //   to: 'genelamaclicari',
                                    //   href: '/#/diger/genelamaclicari'
                                    // },
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'carigenelamaclirapor',
                                        href: '/#/diger/carigenelamaclirapor'
                                    },
    
                                    {
                                        title: this.$t('Debtor-and-Creditor-List'),
                                        to: 'borclu-liste',
                                        href: '#/diger/borclulistesi'
                                    }, {
                                        title: this.$t('Aging-Report'),
                                        to: 'yaslandirmaicmali',
                                        href: '#/diger/yaslandirmaicmali'
                                    },
                                    {
                                        title: this.$t('Cash-Report'),
                                        to: 'kasa-liste',
                                        href: '#/diger/kasaraporu'
                                    },
                                    {
                                        title: 'BA - BS Formu',
                                        group: 'babsform',
                                        items: [{
                                                title: 'BS Formu',
                                                to: 'bsformu',
                                                href: '/#/diger/bsformu'
                                            },
                                            {
                                                title: 'BA Formu',
                                                to: 'baformu',
                                                href: '/#/diger/baformu'
                                            },
                                            {
                                                title: this.$t('Statement-of-Reconciliation'),
                                                to: 'mutabakat-mektubu',
                                                href: '#/diger/mutabakatmektubu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Turnover-Reports'),
                                        group: 'ciroraporu1',
                                        items: [{
                                                title: this.$t('Turnover-Report'),
                                                to: 'ciroraporu',
                                                href: '#/diger/ciroraporu'
                                            },
                                            {
                                                title: this.$t('Turnover-Analysis-Report'),
                                                to: 'ciroanaliz',
                                                href: '#/diger/ciroanaliz'
                                            },
                                            {
                                                title: 'Ciro Kar Analiz Raporu',
                                                to: 'cirokaranalizi',
                                                href: '#/diger/cirokaranalizi'
                                            }
                                        ]
                                    }, {
                                        title: 'Pos Raporları',
                                        group: 'pos',
                                        items: [{
                                                title: this.$t('Bank-POS-Statement'),
                                                to: 'bankaposekstresi',
                                                href: '#/diger/bankaposekstresi'
                                            },
                                            {
                                                title: this.$t('POS-Cost-Report'),
                                                to: 'posmaliyet',
                                                href: '#/diger/posmaliyetraporu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Customer-Profitability-Reports'),
                                        group: 'musterikarlilik',
                                        items: [{
                                            title: this.$t('Customer-Profitability-Report'),
                                            to: 'musterikarlilik',
                                            href: '#/diger/musterikarlilikraporu'
                                        }, {
                                            title: this.$t('Cust-Pro-Report'),
                                            to: 'musterikarlilikodeme',
                                            href: '#/diger/musterikarlilikodeme'
                                        }]
                                    }
                                ]
                            },
    
                            {
                                title: this.$t('Definitions'),
                                grup: 'genelparametre',
                                items: [{
                                        title: this.$t('General-Current-Account'),
                                        to: 'parametre-genel',
                                        href: '#/tanimlamalar/genel'
                                    },
                                    {
                                        title: this.$t('Company-Parameters'),
                                        to: 'parametre-sirket',
                                        href: '#/tanimlamalar/sirket'
                                    }
                                ]
                            },
                            {
                                title: this.$t('Extras'),
                                grup: 'ekstralar',
                                items: [{
                                    title: this.$t('Customer-Personnel-Entry'),
                                    to: 'ekstra-musteri',
                                    href: '#/ekstralar/musteri-personel'
                                }, {
                                    title: this.$t('Profile-Template-Design'),
                                    to: 'ekstralar-profilsablon',
                                    href: '#/ekstralar/profilsablon'
                                }, {
                                    title: this.$t('Template-Data-Entry'),
                                    to: 'ekstralar-verigirisi',
                                    href: '#/ekstralar/sablonverigirisi'
                                }]
                            }, {
                                title: this.$t('Definitions-v2'),
                                to: 'genelparametreler',
                                href: '/#/parametreler/genel'
                            },
                            {
                                title: this.$t('Auxiliaries'),
                                to: 'yardimci-islemler',
                                href: '/#/yardimciislemler/index'
                            },
                            {
                                title: this.$t('Exchange-Entry'),
                                to: 'kurgirisi',
                                href: '/#/cari/kurgirisi'
                            }
                        ]
    
                    },   {
                        icon: 'flight_takeoff',
                        title: this.$t('Ticket'),
                        group: 'bilet',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Ticket-List'),
                                to: 'bilet-listesi',
                                href: '/#/bilet/index'
                            },
                            // {
                            //     title: 'Bilet Alış Fatura Entegrasyonu',
                            //     to: 'bilet-alis-entegre',
                            //     href: '/#/bilet/indexIntegrate'
                            // }, 
                            {
                                title: this.$t('Void-List'),
                                to: 'void-listesi',
                                href: '/#/bilet/voidlistesi'
                            }, {
                                title: this.$t('Refund-List'),
                                to: 'iade-listesi',
                                href: '/#/bilet/iadelistesi'
                            }, {
                                title: this.$t('Reports'),
                                to: 'bilet-raporlar',
                                items: [
                                    // {
                                    //   title: this.$t('General-Purpose-Report'),
                                    //   to: 'genelamacli',
                                    //   href: '/#/bilet/genelamacli'
                                    // },
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'genelamaclirapor',
                                        href: '/#/bilet/genelamaclirapor'
                                    },
                                    {
                                        title: this.$t('Daily-Sales-Report'),
                                        to: 'bilet-gunluksatisraporu',
                                        href: '/#/bilet/gunluksatisraporu'
                                    }, {
                                        title: this.$t('Sales-Distribution'),
                                        to: 'bilet-satisdagilimi',
                                        href: '/#/bilet/satisdagilimi'
                                    }, {
                                        title: this.$t('Customer-Turnover-and-Discount-Statistics'),
                                        to: 'bilet-mustericiroveiskonto',
                                        href: '/#/bilet/mustericiroveiskonto'
                                    },
                                    {
                                        title: this.$t('Income-Distribution-Report'),
                                        to: 'bilet-gelirdagilimiraporu',
                                        href: '/#/bilet/gelirdagilimiraporu'
                                    }, {
                                        title: this.$t('Performance-Analysis-Agent'),
                                        to: 'bilet-kesenkisianaliz',
                                        href: '/#/bilet/kesenkisianaliz'
                                    },
    
                                    {
                                        title: this.$t('Analysis-Report'),
                                        to: 'bilet-analizraporu',
                                        href: '/#/bilet/analizraporu'
                                    },
                                    {
                                        title: this.$t('Comparative-Customer-Monitoring-Report'),
                                        to: 'bilet-mukayeselirapor',
                                        href: '/#/bilet/mukayeselirapor'
                                    },
    
                                    {
                                        title: this.$t('Flight-Report'),
                                        to: 'bilet-ucusraporu',
                                        href: '/#/bilet/ucusraporu'
                                    },
    
                                    {
                                        title: this.$t('Periodic-Reports'),
                                        grup: 'devre-reporları',
    
                                        items: [{
                                                title: 'TK ' + this.$t('Periodic-Report'),
                                                to: 'bilet-tkdevreraporu',
                                                href: '/#/bilet/raporlar/tkdevreraporu'
                                            },
                                            {
                                                title: this.$t('General-Periodic-Report'),
                                                to: 'bilet-geneldevreraporu',
                                                href: '/#/bilet/raporlar/geneldevreraporu'
                                            },
                                            {
                                                title: 'Non IATA ' + this.$t('Periodic-Report'),
                                                to: 'bilet-noniatadevreraporu',
                                                href: '/#/bilet/raporlar/noniatadevreraporu'
                                            },
                                            {
                                                title: 'BSP ' +  this.$t('Periodic-Report'),
                                                to: 'bilet-bspdevreraporu',
                                                href: '/#/bilet/raporlar/bspdevreraporu'
                                            }
                                        ]
                                    },
                                   
                                ]
                            }, {
                                title: this.$t('Ticket-Transfers'),
                                to: 'bilet-aktarimlar',
                                items: [{
                                        title: 'THY ' + this.$t('Transfer'),
                                        to: 'thy-aktarim',
                                        href: '/#/bilet/aktarimbilet/thyaktarim'
                                    }, 
                                    {
                                        title: 'Juniper ' + this.$t('Transfer'),
                                        to: 'juniper-aktarim',
                                        href: '/#/bilet/aktarimbilet/juniperaktarim'
                                    },
                                    {
                                        title: 'AMADEUS ' + this.$t('Transfer'),
                                        to: 'amadeus-aktarim',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarim'
                                    }, {
                                        title: 'AMADEUS ' + this.$t('Transfer') + '(SFTP)',
                                        to: 'amadeus-aktarimftp',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarimftp'
                                    }, {
                                        title: 'PEGASUS ' + this.$t('Transfer'),
                                        to: 'pegasusaktar',
                                        href: '/#/bilet/aktarimbilet/pegasusaktarim'
                                    }, 
                                    {
                                    title: 'PEGASUS Online Aktarım',
                                    to: 'pegasusonlineaktar',
                                    href: '/#/bilet/aktarimbilet/pegasusonlineaktarim'
                                }, 
                                    {
                                        title: 'AJET Excel ' + this.$t('Transfer'),
                                        to: 'ajetaktar',
                                        href: '/#/bilet/aktarimbilet/ajetaktarim'
                                    }, 
                                    {
                                        title: 'AJET Xml ' + this.$t('Transfer'),
                                        to: 'ajetaktarimxml',
                                        href: '/#/bilet/aktarimbilet/ajetaktarimxml'
                                    }, 
                                    {
                                        title: 'ONUR AIR ' + this.$t('Transfer'),
                                        to: 'onurairaktar',
                                        href: '/#/bilet/aktarimbilet/onurairaktar'
                                    }, {
                                        title: 'IATI ' + this.$t('Transfer'),
                                        to: 'iatiaktar',
                                        href: '/#/bilet/aktarimbilet/iatiaktar'
                                    }, {
                                        title: 'SUNEXPRESS ' + this.$t('Transfer'),
                                        to: 'sunexpressaktar',
                                        href: '/#/bilet/aktarimbilet/sunexpressaktar'
                                    }, {
                                        title: 'GALILEO ' + this.$t('Transfer'),
                                        to: 'galileoaktar',
                                        href: '/#/bilet/aktarimbilet/galileoaktar'
                                    }, {
                                        title: 'SABRE ' + this.$t('Transfer'),
                                        to: 'sabreaktar',
                                        href: '/#/bilet/aktarimbilet/sabreaktar'
                                    }, {
                                        title: 'BOOKING AGORA ' + this.$t('Transfer'),
                                        to: 'bookingagoraaktar',
                                        href: '/#/bilet/aktarimbilet/bookingagoraaktar'
                                    },
                                    {
                                        title: 'FLY KHY ' + this.$t('Transfer'),
                                        to: 'lydiaaktar',
                                        href: '/#/bilet/aktarimbilet/lydiaaktar'
                                    },
                                    {
                                        title: 'ATLAS ' +  this.$t('Transfer'),
                                        to: 'atlasaktar',
                                        href: '/#/bilet/aktarimbilet/atlasaktar'
                                    },
                                    {
                                        title: 'BIZITRAVEL ' + this.$t('Transfer'),
                                        to: 'bizitravelaktar',
                                        href: '/#/bilet/aktarimbilet/bizitravelaktar'
                                    },
                                    {
                                        title: 'BILETBANK ' + this.$t('Transfer'),
                                        to: 'biletbankaktar',
                                        href: '/#/bilet/aktarimbilet/biletbankaktar'
                                    },
                                    {
                                        title: 'BILETALL ' + this.$t('Transfer'),
                                        to: 'biletallaktar',
                                        href: '/#/bilet/aktarimbilet/biletallaktar'
                                    },
                                    {
                                        title: 'Turkmen Air ' + this.$t('Transfer'),
                                        to: 'turkmanairaktar',
                                        href: '/#/bilet/aktarimbilet/turkmanairaktar'
                                    },
                                    {
                                        title: 'THY XML ' + this.$t('Transfer'),
                                        to: 'thy-aktarim-xml',
                                        href: '/#/bilet/biletaktarim/thyaktarimxml'
                                    },
                                    {
                                        title: 'Arkman ' + this.$t('Transfer'),
                                        group: 'arkmanaktarim',
                                        items: [{
                                                title: 'XML '+ this.$t('Transfer'),
                                                to: 'arkmanxmlaktar',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlaktar'
                                            }, {
                                                title: 'Arkman XML Export',
                                                to: 'arkmanxmlexport',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlexport'
                                            },
                                            {
                                                title: 'EXCEL ' + this.$t('Transfer'),
                                                to: 'excelaktar',
                                                href: '/#/bilet/aktarimbilet/excelaktar'
                                            }
                                        ]
                                    }
    
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'bilet-tanimlamalar',
                                href: '/#/bilet/tanimlamalar'
                            }
                        ]
                    },
                  
                    //  Coper başla
                    {
                        icon: 'hotel',
                        title: 'Coper (Beta)',
                        group: 'coper',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Booking-List'),
                                to: 'coper-rezervasyonlistesiGuncel',
                                href: '/#/coper/rezervasyon/rezervasyonlistesi'
                            },
                            {
                        icon: 'inventory',
                        title: this.$t('Visa-Procedures'),
                        to: 'coper-vize-yeni',
                        href: '/#/coper/vize/yeni/id?islem=yeni'
                        },
                            {
                                title: this.$t('Sellers'),
                                group: 'saticilar',
                                items: [{
                                    title: this.$t('Hotel-List'),
                                    to: 'coper-otel-listesi',
                                    href: '/#/coper/otel/index'
                                }, {
                                    title: this.$t('Transfer-v4'),
                                    to: 'coper-transfer-listesi',
                                    href: '/#/coper/transfer/index'
                                }, {
                                    title: 'Restaurant',
                                    to: 'coper-restaurant-listesi',
                                    href: '/#/coper/restaurant/index'
                                }, {
                                    title: this.$t('Agency'),
                                    to: 'coper-acente-listesi',
                                    href: '/#/coper/acente/index'
                                }, {
                                    title: this.$t('Rent-A-Car'),
                                    to: 'coper-rentacar-listesi',
                                    href: '/#/coper/rentacar/index'
                                }, {
                                    title: this.$t('Guide'),
                                    to: 'coper-rehber-listesi',
                                    href: '/#/coper/rehber/index'
                                }, {
                                    title: this.$t('Museum'),
                                    to: 'coper-muze-listesi',
                                    href: '/#/coper/muze/index'
                                }, {
                                    title: this.$t('Charter'),
                                    to: 'coper-charter-listesi',
                                    href: '/#/coper/charter/index'
                                }, {
                                    title: this.$t('Cruise'),
                                    to: 'coper-gemi-listesi',
                                    href: '/#/coper/gemi/index'
                                }, {
                                    title: this.$t('Other'),
                                    to: 'coper-diger-listesi',
                                    href: '/#/coper/diger/index'
                                }, {
                                    title: this.$t('Visa'),
                                    to: 'coper-vize-listesi',
                                    href: '/#/coper/vize/index'
                                }, {
                                    title: this.$t('Tour-Operator'),
                                    to: 'coper-turoperator-listesi',
                                    href: '/#/coper/turoperator/index'
                                }, {
                                    title: this.$t('Insurance'),
                                    to: 'coper-sigorta-listesi',
                                    href: '/#/coper/sigorta/index'
                                }, {
                                    title: this.$t('Ferry'),
                                    to: 'coper-feribot-listesi',
                                    href: '/#/coper/feribot/index'
                                }, {
                                    title: 'Golf',
                                    to: 'coper-golf-listesi',
                                    href: '/#/coper/golf/index'
                                }]
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'coperraporlar',
                                items: [{
                                    title: this.$t('Sales-Report'),
                                    to: 'coper-satisraporu',
                                    href: '/#/coper/raporlar/satisraporu'
                                }, {
                                    title: this.$t('Profitability-Report'),
                                    to: 'coper-karlilikraporu',
                                    href: '/#/coper/raporlar/karlilikraporu'
                                }, {
                                    title: this.$t('Seller-Payment-Report'),
                                    to: 'coper-odemeraporu',
                                    href: '/#/coper/raporlar/odemeraporu'
                                }, {
                                    title: this.$t('Invoices-Received-Not-Received'),
                                    to: 'coper-faturasigelengelmeyenraporu',
                                    href: '/#/coper/raporlar/faturasigelengelmeyen'
                                },
                                {
                                    title: this.$t('Daily-Tour-List'),
                                    to: 'coper-gunluktur',
                                    href: '/#/coper/raporlar/gunlukturlistesi'
                                }, 
                            ]
                            },
                            {
                                title: 'Coper ' + this.$t('Forms'),
                                group: 'faturaraporlar',
                                items: [{
                                        title: this.$t('Quotation-Form'),
                                        to: 'coper-kotasyonformu',
                                        params:'islem=yeni',
                                        href: '/#/coper/page/formlar/kotasyonformu/id'
                                    },
    
                                ]
                            },
                            {
                                title: this.$t('Payments'),
                                group: 'coperodemeler',
                                items: [{
                                        title: this.$t('Seller-Payments'),
                                        to: 'coper-saticiodemeler',
                                        href: '/#/coper/odemeler/saticiodemelistesi'
                                    },
    
                                ]
                            },
                            {
                                title: this.$t('Advertisements'),
                                group: 'copertanitimlar',
                                items: [{
                                        title: 'Parametreler',
                                        to: 'coper-tanitimlar-parametrelist',
                                        href: '/#/coper/tanitimlar/parametreler'
                                    },{
                                        title: 'Adresler',
                                        to: 'coper-adreslistesi',
                                        href: '/#/coper/tanitimlar/adreslistesi'
                                    },
                                    {
                                        title: this.$t('Hotel-List'),
                                        to: 'coper-tanitimlar-otellistesi',
                                        href: '/#/coper/tanitimlar/Otellistesi/otellistesi'
                                    },
                                    {
                                        title: this.$t('Collection'),
                                        to: 'coper-odemelistesi',
                                        href: '/#/coper/tanitimlar/odeme'
                                    },
                                    {
                                        title: this.$t('Agency-Commission') ,
                                        to: 'coper-tanitimlar-acentekomisyon',
                                        href: '/#/coper/tanitimlar/acentekomisyon'
                                    }, {
                                        title: this.$t('Profitability'),
                                        to: 'coper-tanitimlar-karlilik',
                                        href: '/#/coper/tanitimlar/karlilik'
                                    },
                                    {
                                        title: this.$t('Visa-Price'),
                                        to: 'coper-tanitimlar-vizefiyatlist',
                                        href: '/#/coper/tanitimlar/vizefiyat/index'
                                    },
                                    {
                                        title: 'Otel Kategori',
                                        to: 'coper-otelkategori',
                                        href: '/#/coper/tanitimlar/otelkategori'
                                    },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'coperaktarimlar',
                                items: [{
                                        title: 'Bizitravel',
                                        to: 'coper-aktarim-bizitravel',
                                        href: '/#/coper/aktarim/bizitravel'
                                    },
                                    {
                                        title: 'Booking Agora',
                                        to: 'coper-aktarim-bookingagora',
                                        href: '/#/coper/aktarim/bookingagora'
                                    },
                                ]
                            },
                        ]
                    },
                    {
                                icon: 'account_balance',
                                title: 'Resmi Muhasebe (Beta)',
                                group: 'muhasebe',
                                color: 'blue darken-2',
                                items: [
                                    {
                                        title: 'Muhasebe Kod Listesi',
                                        to: 'muhasebe-muhasebekodlari',
                                        href: '/#/muhasebe/muhasebekodlari/liste'
                                    },
                                    {
                                         title: 'Fis Listesi',
                                         to: 'muhasebe-fisler-liste',
                                         href: '/#/muhasebe/fisler/liste'
                                        },
                                        {
                                         title: 'Tevkifat Bağlantıları',
                                         to: 'muhasebe-tevkifat-baglanti',
                                         href: '/#/muhasebe/muhasebekodlari/tevkifatbaglanti'
                                        },
                                        {
                                        title: 'Raporlar',
                                        group: 'muhaseberaporlar',
                                        items: [
                                            {
                                                title: 'Ekstreler',
                                                group: 'mhekstreler',
                                                items :[
                                                {    
                                        title: 'Hesap Ekstresi',
                                        to: 'muhasebe-rapor-hesap',
                                        href: '/#/muhasebe/raporlar/hesabagore'
                                        },
                                        {    
                                        title: 'Referans Ekstresi',
                                        to: 'muhasebe-rapor-referans',
                                        href: '/#/muhasebe/raporlar/referansagore'
                                        },
                                       
                                                ]
                                            },
                                       {
                                        title: 'Mizanlar',
                                        group: 'mhmizanlar',
                                        items: [
                                        {
                                        title: this.$t('Accounting-Balance'),
                                        to: 'muhasebe-rapor-mizan',
                                        href: '/#/muhasebe/raporlar/mizan'
                                        },
                                        {
                                        title: 'Referansa Göre Mizan',
                                        to: 'muhasebe-referans-mizan',
                                        href: '/#/muhasebe/raporlar/referansmizan'
                                        },
                                        ]
                                       },
                                       {    
                                        title: 'Borç Yaşlandırma',
                                        to: 'muhasebe-rapor-borcyaslandirma',
                                        href: '/#/muhasebe/raporlar/borcyaslandirma'
                                        },
                                        {    
                                        title: 'Alacak Yaşlandırma',
                                        to: 'muhasebe-rapor-alacakyaslandirma',
                                        href: '/#/muhasebe/raporlar/alacakyaslandirma'
                                        },
                                       {
                                        title: 'Muhasebe Yekun Kontrolü' ,
                                        to: 'muhasebe-rapor-yekunkontrolu',
                                        href: '/#/muhasebe/raporlar/mizan'
                                        }
                                        ]
                                    },
                                    {
                                        title: 'Resmi Defterler',
                                        group: 'muhaseberesmidefterler',
                                        items: [
                                        {
                                        title: "Mükerrer Fiş No Kontrol",
                                        to: 'muhasebe-resmidefter-mukerrerfiskontrol',
                                        href: '/#/muhasebe/resmidefter/mukerrerfiskontrol'
                                        },
                                        {
                                        title: "E-Defter Schematron Kontrolü",
                                        to: 'muhasebe-resmidefter-schematronkontrol',
                                        href: '/#/muhasebe/resmidefter/schematronkontrol'
                                        },
                                        {
                                        title: this.$t('Create-Ledger'),
                                        to: 'muhasebe-resmidefter-defterolustur',
                                        href: '/#/muhasebe/raporlar/defterolustur'
                                        },{
                                        title: this.$t('Delete-Ledger'),
                                        to: 'muhasebe-resmidefter-deftersil',
                                        href: '/#/muhasebe/raporlar/deftersil'
                                        },
                                        {
                                        title: 'E-Defter',
                                        to: 'muhasebe-edefter-edefterexport',
                                        href: '/#/muhasebe/edefter/edefterexport'
                                    }, 
    
                                            ]
                                     },
                                     {
                                        title: 'Entegrasyon',
                                        group: 'muhasebeentegrasyon',
                                        items: [{
                                        title: 'Bilet',
                                        group: 'biletentegrasyon',
                                        items: [{
                                                title: 'Şablon Girişi',
                                                to: 'muhasebe-entegrasyon-bilet',
                                                href: '/#/entegrasyon/biletent'
                                                },
                                                {
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-bilet-entegre',
                                                href: '/#/entegrasyon/biletentegre'
                                                }
                                        ]
                                        },{
                                        title: 'Cari Hareket',
                                        group: 'carihareketent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-carihareket',
                                                href: '/#/entegrasyon/carihareket/carient'
                                                }
                                        ]
                                        },{
                                        title: this.$t('Free-Invoice'),
                                        group: 'serbestfaturaent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-serbestfatura-entegre',
                                                href: '/#/entegrasyon/serbestfatura/serbestent'
                                                }
                                        ]
                                        },{
                                        title: 'Coper',
                                        group: 'coperent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-coper',
                                                href: '/#/entegrasyon/coperentegre'
                                                }
                                        ]
                                        },
                                        
                                        ]
                                      
                                    },
                                    {
                                        title: this.$t('Definitions-v2'),
                                        to: 'muhasebe-tanimlamalar',
                                        href: '/#/muhasebe/tanimlamalar'
                                    },
                                    {
                                        title: this.$t('Helpers'),
                                        to: 'muhasebe-yardimcilar',
                                        href: '/#/muhasebe/yardimcilar/index'
                                    },
                                    {
                                        title: this.$t('Parameters'),
                                        to: 'muhasebe-parametreler',
                                        href: '/#/muhasebe/parametreler'
                                    },
                                   
                                ]
                    },
                                    
                        {
                        icon: 'receipt',
                        title: this.$t('Bills'),
                        group: 'faturalar',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Sales-Invoice-List'),
                                to: 'faturalistesi',
                                href: '/#/fatura/faturalistesi'
                            }, {
                                title: this.$t('List-of-Invoices-Received'),
                                to: 'gelenfaturalistesi',
                                href: '/#/fatura/gelenfaturalistesi'
                            },
                            {
                                title: this.$t('Ticket-Self-invoice'),
                                to: 'fatura-basma',
                                href: '/#/fatura/faturabasma'
                            },
                            {
                                title: this.$t('Invoice-Status-Query'),
                                to: 'faturasorgula',
                                href: '/#/fatura/faturadurumsorgula'
                            },
                            {
                                title: 'E-Fatura (BETA)',
                                group: 'coper-e-faturalar',
                                items: [ {
                                title: "Gelen Fatura Listesi",
                                to: 'fatura-EFaturaListesi',
                                href: '/#/fatura/gelenEFaturaListesi'
                                },{
                                title: this.$t('Save-Received-E-Invoices-Archive'),
                                to: 'fatura-EFaturalariHavuzaKaydet',
                                href: '/#/fatura/gelenEFaturalariHavuzaKaydet'
                                },{
                                title: this.$t('Invoice-Status-Query'),
                                to: 'faturasorgula',
                                href: '/#/fatura/faturadurumsorgula'
                                },
                                ]
                            },
                             {
                                title: 'Coper',
                                group: 'coperfaturalar',
                                items: [ {
                                title: this.$t('Bulk-Invoice'),
                                to: 'fatura-copertoplufaturalistesi',
                                href: '/#/fatura/copertoplufatura'
                                },{
                                title: this.$t('Invoice-Received'),
                                to: 'coper-gelenfaturalistesi',
                                href: '/#/coper/page/formlar/gelenfaturalistesi'
                                },{
                                title: this.$t('Commission-Invoice'),
                                to: 'coper-komisyonfaturasi',
                                href: '/#/coper/komisyonfaturasi/index'
                                }, {
                                title: this.$t('Sales-Return-Invoice-List'),
                                to: 'fatura-coper-satisiade',
                                href: '/#/fatura/copersatisiade'
                                },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'aktarimlar',
                                items: [{
                                    title: this.$t('Free-Invoice-Transfers'),
                                    to: 'fatura-aktarimlar-serbestfatura',
                                    href: '/#/fatura/aktarimlar/serbestfaturaexcel'
                                }, 
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'faturatanimlamalar',
                                href: '/#/fatura/tanimlamalar'
                            }, {
                                title: this.$t('Settings'),
                                to: 'faturaayarlar',
                                href: '/#/fatura/ayarlar'
                            },
                            // {
                            //     title: 'Satış Fatura Entegrasyonu',
                            //     to: 'faturaentegrasyon',
                            //     href: '/#/fatura/faturaentegrasyon'
                            // },
    
                        ]
    
                    },
                //      {
                //        icon: 'undo',
                //        title: 'Paket Tur',
                //        group: 'pakettur',
                //        color: 'blue darken-2',
                //        items: [   
                           
                //            {
                //                icon: 'directions_bus',
                //                title: 'Master Paketler',
                //                to: 'masterpaket',
                //                href: '/#/pakettur/masterpaket'
                //            },
                          
                //         ]
                //    }, 
                    {
                            icon: 'explicit',
                            title: this.$t('Integration'),
                            to: 'entegrasyon-index',
                            href: '/#/entegrasyon/index'
                        },
                        {
                            icon: 'widgets',
                            title: this.$t('Additional-Products'),
                            to: 'ek-urunler',
                            href: '/#/urunler/ekurunler'
    
                        },
                        {
                            icon: 'cloud_download',
                            title: 'Next ' + this.$t('Upload-Ticket'),
                            color: 'blue darken-2',
                            to: 'download-page',
                            href: '/#/download/index'
                        },
                        ]
                    },
                  {
                        icon: 'add_business',
                        title: this.$t('Sales'),
                        group: 'satis',
                        color: 'blue darken-2',
                        items: [ 
                            {
                                icon:'hotel',
                                title: 'Hotel Runner',
                                group: 'runner',
                                items: [{
                                icon: 'maps_home_work',
                                title:  this.$t('Hotel'),
                                to: 'coper-hotelrunner',
                                params: 'isl=hryeni',
                                href: '/#/hotelrunner/index',
                                },{
                                icon: 'maps_home_work',
                                title: this.$t('Hotel-List'),
                                to: 'coper-hotelrunner-list',
                                href: '/#/hotelrunner/oteltanitim/list',
                                }
                                ]
                            },
                            {
                                icon: 'directions_bus',
                                title: this.$t('Transfer-v4'),
                                to: 'coper-paxdrive',
                                params: 'islemTipi=pdyeni',
                                href: '/#/coper/paxdrive/index/id'
                            },
                            {
                                icon:'flight',
                                title: this.$t('Flight'),
                                group: 'ucus',
                                items: [{
                                    title: this.$t('Search-Flight'),
                                    to: 'satis-ucus-liste',
                                    href: '/#/satis/ucak/index'
                                }, {
                                    title: this.$t('Reservation-List'),
                                    to: 'satis-ucus-rezliste',
                                    href: '/#/satis/ucak/rezervasyonliste'
                                },
                                ]
                            },
                            // {
                            //     icon:'face',
                            //     title: 'Saç Ekim',
                            //     group: 'sacekim',
                            //     items: [{
                            //         title: 'Saç Ekim Form',
                            //         to: 'coper-clinista',
                            //         href: '/#/coper/clinista/index'
                            //     }, {
                            //         title: 'İstek Listesi',
                            //         to: 'coper-clinistaacenteliste',
                            //         href: '/#/coper/clinista/acenteisteklistesi'
                            //     },
                            //     ]
                            // },
                        ]
                    },
                          {
                        icon: 'help',
                        title: this.$t('Help'),
                        to: 'yardim',
                        href: '/#/diger/yardim'
                        },
                  
                ],
                
                items2: [
                // {
                //         icon: 'home',
                //         title: this.$t('mainpage_menu'),
                //         to: 'Deneme1',
                //         href: '/#/test/deneme'
                //     },   
                {
                        icon: 'home',
                        title: this.$t('mainpage_menu'),
                        to: 'home',
                        href: '/#/'
                    },
                    {
                        icon: 'today',
                        title: this.$t('Calendar'),
                        to: 'takvim',
                        href: '/#/takvim/takvim'
                    },
                    {
                        icon: 'attach_money',
                        title: this.$t('Current-Account'),
                        group: 'cari',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('current_index_header'),
                                to: 'cari-index',
                                href: '/#/cari/index'
                            },
                            {
                                title: this.$t('Current-Movements'),  
                                to: 'carihareketler-index',
                                href: '/#/carihareketler/index'
                            },
                            {
                                title: this.$t('Extract'),
                                group: 'ekstreler',
                                namespace: 'cari',
                                items: [{
                                        title: this.$t('Extract-of-Account'),
                                        to: 'ekstre-hesap',
                                        href: '/#/ekstreler/hesabagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Date'),
                                        to: 'ekstre-tarih',
                                        href: '/#/ekstreler/tarihegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Reference'),
                                        to: 'ekstre-referans',
                                        href: '/#/ekstreler/referansagore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Expence-Center'),
                                        to: 'ekstre-masraf',
                                        href: '/#/ekstreler/masrafmerkezinegore'
                                    },
                                    {
                                        title: this.$t('Extract-of-Firm-Card'),
                                        to: 'ekstre-firmakart',
                                        href: '/#/ekstreler/firkakartinagore'
    
                                    },
                                ]
                            },
                            {
                                title: this.$t('Bank-transactions'),
                                group: 'banka',
                                namespace: 'banka',
                                items: [{
                                        title: this.$t('Bank-transactions'),
                                        to: 'bankaentegrasyonu-online-banka-hareketleri',
                                        href: '/#/bankaentegrasyonu/bankahareketleri'
                                    },
                                ],
                            },
                            {
                                title: this.$t('Trial-Balance'),
                                group: 'mizanlar',
                                namespace: 'mizan',
                                items: [{
                                        title: this.$t('Trial-Balance-of-Account'),
                                        to: 'mizan-carihesap',
                                        href: '/#/mizan/carihesap'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Currency'),
                                        to: 'mizan-doviz',
                                        href: '/#/mizan/doviz'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Expense-Center'),
                                        to: 'mizan-masrafmerkezi',
                                        href: '/#/mizan/masrafmerkezi'
                                    },
                                    {
                                        title: this.$t('Trial-Balance-of-Reference'),
                                        to: 'mizan-referans',
                                        href: '/#/mizan/referans'
                                    }
                                ],
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'diger',
                                items: [
                                   
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'carigenelamaclirapor',
                                        href: '/#/diger/carigenelamaclirapor'
                                    },
    
                                    {
                                        title: this.$t('Debtor-and-Creditor-List'),
                                        to: 'borclu-liste',
                                        href: '#/diger/borclulistesi'
                                    }, {
                                        title: this.$t('Aging-Report'),
                                        to: 'yaslandirmaicmali',
                                        href: '#/diger/yaslandirmaicmali'
                                    },
                                    {
                                        title: this.$t('Cash-Report'),
                                        to: 'kasa-liste',
                                        href: '#/diger/kasaraporu'
                                    },
                                    {
                                        title: 'BA - BS Formu',
                                        group: 'babsform',
                                        items: [{
                                                title: 'BS Formu',
                                                to: 'bsformu',
                                                href: '/#/diger/bsformu'
                                            },
                                            {
                                                title: 'BA Formu',
                                                to: 'baformu',
                                                href: '/#/diger/baformu'
                                            },
                                            {
                                                title: this.$t('Statement-of-Reconciliation'),
                                                to: 'mutabakat-mektubu',
                                                href: '#/diger/mutabakatmektubu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Turnover-Reports'),
                                        group: 'ciroraporu1',
                                        items: [{
                                                title: this.$t('Turnover-Report'),
                                                to: 'ciroraporu',
                                                href: '#/diger/ciroraporu'
                                            },
                                            {
                                                title: this.$t('Turnover-Analysis-Report'),
                                                to: 'ciroanaliz',
                                                href: '#/diger/ciroanaliz'
                                            },
                                            {
                                                title: 'Ciro Kar Analiz Raporu',
                                                to: 'cirokaranalizi',
                                                href: '#/diger/cirokaranalizi'
                                            }
                                        ]
                                    }, {
                                        title: 'Pos Raporları',
                                        group: 'pos',
                                        items: [{
                                                title: this.$t('Bank-POS-Statement'),
                                                to: 'bankaposekstresi',
                                                href: '#/diger/bankaposekstresi'
                                            },
                                            {
                                                title: this.$t('POS-Cost-Report'),
                                                to: 'posmaliyet',
                                                href: '#/diger/posmaliyetraporu'
                                            }
                                        ]
                                    }, {
                                        title: this.$t('Customer-Profitability-Reports'),
                                        group: 'musterikarlilik',
                                        items: [{
                                            title: this.$t('Customer-Profitability-Report'),
                                            to: 'musterikarlilik',
                                            href: '#/diger/musterikarlilikraporu'
                                        }, {
                                            title: this.$t('Cust-Pro-Report'),
                                            to: 'musterikarlilikodeme',
                                            href: '#/diger/musterikarlilikodeme'
                                        }]
                                    }
                                ]
                            },
    
                            {
                                title: this.$t('Definitions'),
                                grup: 'genelparametre',
                                items: [{
                                        title: this.$t('General-Current-Account'),
                                        to: 'parametre-genel',
                                        href: '#/tanimlamalar/genel'
                                    },
                                    {
                                        title: this.$t('Company-Parameters'),
                                        to: 'parametre-sirket',
                                        href: '#/tanimlamalar/sirket'
                                    }
                                ]
                            },
                            {
                                title: this.$t('Extras'),
                                grup: 'ekstralar',
                                items: [{
                                    title: this.$t('Customer-Personnel-Entry'),
                                    to: 'ekstra-musteri',
                                    href: '#/ekstralar/musteri-personel'
                                }, {
                                    title: this.$t('Profile-Template-Design'),
                                    to: 'ekstralar-profilsablon',
                                    href: '#/ekstralar/profilsablon'
                                }, {
                                    title: this.$t('Template-Data-Entry'),
                                    to: 'ekstralar-verigirisi',
                                    href: '#/ekstralar/sablonverigirisi'
                                }]
                            }, {
                                title: this.$t('Definitions-v2'),
                                to: 'genelparametreler',
                                href: '/#/parametreler/genel'
                            },
                            {
                                title: this.$t('Auxiliaries'),
                                to: 'yardimci-islemler',
                                href: '/#/yardimciislemler/index'
                            },
                            {
                                title: this.$t('Exchange-Entry'),
                                to: 'kurgirisi',
                                href: '/#/cari/kurgirisi'
                            }
                        ]
    
                    },
                    {
                        icon: 'flight_takeoff',
                        title: this.$t('Ticket'),
                        group: 'bilet',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Ticket-List'),
                                to: 'bilet-listesi',
                                href: '/#/bilet/index'
                            }, 
                            // {
                            //     title: 'Bilet Alış Fatura Entegrasyonu',
                            //     to: 'bilet-alis-entegre',
                            //     href: '/#/bilet/indexIntegrate'
                            // }, 
                            {
                                title: this.$t('Void-List'),
                                to: 'void-listesi',
                                href: '/#/bilet/voidlistesi'
                            }, {
                                title: this.$t('Refund-List'),
                                to: 'iade-listesi',
                                href: '/#/bilet/iadelistesi'
                            }, {
                                title: this.$t('Reports'),
                                to: 'bilet-raporlar',
                                items: [
                                   
                                    {
                                        title: this.$t('General-Purpose-Report'),
                                        to: 'genelamaclirapor',
                                        href: '/#/bilet/genelamaclirapor'
                                    },
                                    {
                                        title: this.$t('Daily-Sales-Report'),
                                        to: 'bilet-gunluksatisraporu',
                                        href: '/#/bilet/gunluksatisraporu'
                                    }, {
                                        title: this.$t('Sales-Distribution'),
                                        to: 'bilet-satisdagilimi',
                                        href: '/#/bilet/satisdagilimi'
                                    }, {
                                        title: this.$t('Customer-Turnover-and-Discount-Statistics'),
                                        to: 'bilet-mustericiroveiskonto',
                                        href: '/#/bilet/mustericiroveiskonto'
                                    },
                                    {
                                        title: this.$t('Income-Distribution-Report'),
                                        to: 'bilet-gelirdagilimiraporu',
                                        href: '/#/bilet/gelirdagilimiraporu'
                                    }, {
                                        title: this.$t('Performance-Analysis-Agent'),
                                        to: 'bilet-kesenkisianaliz',
                                        href: '/#/bilet/kesenkisianaliz'
                                    }, {
                                        title: this.$t('Return-Ticket-Invoice-Control'),
                                        to: 'bilet-iadebiletfatura',
                                        href: '/#/bilet/raporlar/iadebiletfatura'
                                    },
                                    {
                                        title: this.$t('Analysis-Report'),
                                        to: 'bilet-analizraporu',
                                        href: '/#/bilet/analizraporu'
                                    },
                                    {
                                        title: this.$t('Comparative-Customer-Monitoring-Report'),
                                        to: 'bilet-mukayeselirapor',
                                        href: '/#/bilet/mukayeselirapor'
                                    },
    
                                    {
                                        title: this.$t('Flight-Report'),
                                        to: 'bilet-ucusraporu',
                                        href: '/#/bilet/ucusraporu'
                                    },
    
                                    {
                                        title: this.$t('Periodic-Reports'),
                                        grup: 'devre-reporları',
    
                                        items: [{
                                                title: 'TK '+ this.$t('Periodic-Report'),
                                                to: 'bilet-tkdevreraporu',
                                                href: '/#/bilet/raporlar/tkdevreraporu'
                                            },
                                            {
                                                title: this.$t('General-Periodic-Report'),
                                                to: 'bilet-geneldevreraporu',
                                                href: '/#/bilet/raporlar/geneldevreraporu'
                                            },
                                            {
                                                title: 'Non IATA ' + this.$t('Periodic-Report'),
                                                to: 'bilet-noniatadevreraporu',
                                                href: '/#/bilet/raporlar/noniatadevreraporu'
                                            },
                                            {
                                                title: 'BSP ' + this.$t('Periodic-Report'),
                                                to: 'bilet-bspdevreraporu',
                                                href: '/#/bilet/raporlar/bspdevreraporu'
                                            }
                                        ]
                                    },
                                     {
                                        title: "Diğer Raporlar",
                                        grup: 'diger-reporları',
    
                                        items: [{
                                                title: 'Borusan Raporu',
                                                to: 'bilet-diger-borusan',
                                                href: '/#/bilet/raporlar/digerraporlar/tkdevreraporu'
                                            },
                                           
                                        ]
                                    }
                                ]
                            }, {
                                title: this.$t('Ticket-Transfers'),
                                to: 'bilet-aktarimlar',
                                items: [{
                                        title: 'THY ' + this.$t('Transfer'),
                                        to: 'thy-aktarim',
                                        href: '/#/bilet/aktarimbilet/thyaktarim'
                                    },
                                    {
                                        title: 'AMADEUS ' + this.$t('Transfer'),
                                        to: 'amadeus-aktarim',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarim'
                                    }, {
                                        title: 'AMADEUS ' + this.$t('Transfer') + '(SFTP)',
                                        to: 'amadeus-aktarimftp',
                                        href: '/#/bilet/aktarimbilet/amadeusaktarimftp'
                                    },
                                    {
                                        title: 'PEGASUS ' + this.$t('Transfer'),
                                        to: 'pegasusaktar',
                                        href: '/#/bilet/aktarimbilet/pegasusaktarim'
                                    }, 
                                    {
                                    title: 'PEGASUS Online Aktarım',
                                    to: 'pegasusonlineaktar',
                                    href: '/#/bilet/aktarimbilet/pegasusonlineaktarim'
                                }, 
                                    {
                                        title: 'AJET Excel ' + this.$t('Transfer'),
                                        to: 'ajetaktar',
                                        href: '/#/bilet/aktarimbilet/ajetaktarim'
                                    }, 
                                    {
                                        title: 'AJET Xml ' + this.$t('Transfer'),
                                        to: 'ajetaktarimxml',
                                        href: '/#/bilet/aktarimbilet/ajetaktarimxml'
                                    }, 
                                    {
                                        title: 'ONUR AIR ' + this.$t('Transfer'),
                                        to: 'onurairaktar',
                                        href: '/#/bilet/aktarimbilet/onurairaktar'
                                    }, {
                                        title: 'IATI ' + this.$t('Transfer'),
                                        to: 'iatiaktar',
                                        href: '/#/bilet/aktarimbilet/iatiaktar'
                                    }, {
                                        title: 'SUNEXPRESS ' + this.$t('Transfer'),
                                        to: 'sunexpressaktar',
                                        href: '/#/bilet/aktarimbilet/sunexpressaktar'
                                    }, {
                                        title: 'GALILEO ' + this.$t('Transfer'),
                                        to: 'galileoaktar',
                                        href: '/#/bilet/aktarimbilet/galileoaktar'
                                    }, {
                                        title: 'SABRE ' + this.$t('Transfer'),
                                        to: 'sabreaktar',
                                        href: '/#/bilet/aktarimbilet/sabreaktar'
                                    }, {
                                        title: 'BOOKING AGORA ' + this.$t('Transfer'),
                                        to: 'bookingagoraaktar',
                                        href: '/#/bilet/aktarimbilet/bookingagoraaktar'
                                    },
                                    {
                                        title: 'FLY KHY ' + this.$t('Transfer'),
                                        to: 'lydiaaktar',
                                        href: '/#/bilet/aktarimbilet/lydiaaktar'
                                    },
                                    {
                                        title: 'ATLAS ' + this.$t('Transfer'),
                                        to: 'atlasaktar',
                                        href: '/#/bilet/aktarimbilet/atlasaktar'
                                    },
                                    {
                                        title: 'BIZITRAVEL ' + this.$t('Transfer'),
                                        to: 'bizitravelaktar',
                                        href: '/#/bilet/aktarimbilet/bizitravelaktar'
                                    },
                                    {
                                        title: 'BILETBANK ' + this.$t('Transfer'),
                                        to: 'biletbankaktar',
                                        href: '/#/bilet/aktarimbilet/biletbankaktar'
                                    },
                                    {
                                        title: 'BILETALL ' + this.$t('Transfer'),
                                        to: 'biletallaktar',
                                        href: '/#/bilet/aktarimbilet/biletallaktar'
                                    },
                                    {
                                        title: 'Turkmen Air ' + this.$t('Transfer'),
                                        to: 'turkmanairaktar',
                                        href: '/#/bilet/aktarimbilet/turkmanairaktar'
                                    },
                                    {
                                        title: 'THY XML ' + this.$t('Transfer'),
                                        to: 'thy-aktarim-xml',
                                        href: '/#/bilet/biletaktarim/thyaktarimxml'
                                    },
                                    {
                                        title: 'Arkman ' + this.$t('Transfer'),
                                        group: 'arkmanaktarim',
                                        items: [{
                                                title: 'XML ' + this.$t('Transfer'),
                                                to: 'arkmanxmlaktar',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlaktar'
                                            }, {
                                                title: 'Arkman XML Export',
                                                to: 'arkmanxmlexport',
                                                href: '/#/bilet/aktarimbilet/arkmanxmlexport'
                                            },
                                            {
                                                title: 'EXCEL ' + this.$t('Transfer'),
                                                to: 'excelaktar',
                                                href: '/#/bilet/aktarimbilet/excelaktar'
                                            }
                                        ]
                                    }
    
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'bilet-tanimlamalar',
                                href: '/#/bilet/tanimlamalar'
                            }
                        ]
                    },
    
                    //  Coper başla
                    {
                        icon: 'hotel',
                        title: 'Coper ',
                        group: 'coper',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Booking-List'),
                                to: 'coper-rezervasyonlistesiGuncel',
                                href: '/#/coper/rezervasyon/rezervasyonlistesi'
                            },
                            {
                                title: this.$t('Sellers'),
                                group: 'saticilar',
                                items: [{
                                    title: this.$t('Hotel-List'),
                                    to: 'coper-otel-listesi',
                                    href: '/#/coper/otel/index'
                                }, {
                                    title: 'Transfer',
                                    to: 'coper-transfer-listesi',
                                    href: '/#/coper/transfer/index'
                                }, {
                                    title: 'Restaurant',
                                    to: 'coper-restaurant-listesi',
                                    href: '/#/coper/restaurant/index'
                                }, {
                                    title: this.$t('Agency'),
                                    to: 'coper-acente-listesi',
                                    href: '/#/coper/acente/index'
                                }, {
                                    title: this.$t('Rent-A-Car'),
                                    to: 'coper-rentacar-listesi',
                                    href: '/#/coper/rentacar/index'
                                }, {
                                    title: this.$t('Guide'),
                                    to: 'coper-rehber-listesi',
                                    href: '/#/coper/rehber/index'
                                }, {
                                    title: this.$t('Museum'),
                                    to: 'coper-muze-listesi',
                                    href: '/#/coper/muze/index'
                                }, {
                                    title: this.$t('Charter'),
                                    to: 'coper-charter-listesi',
                                    href: '/#/coper/charter/index'
                                }, {
                                    title: this.$t('Cruise'),
                                    to: 'coper-gemi-listesi',
                                    href: '/#/coper/gemi/index'
                                }, {
                                    title: this.$t('Other'),
                                    to: 'coper-diger-listesi',
                                    href: '/#/coper/diger/index'
                                }, {
                                    title: this.$t('Visa'),
                                    to: 'coper-vize-listesi',
                                    href: '/#/coper/vize/index'
                                }, {
                                    title: this.$t('Tour-Operator'),
                                    to: 'coper-turoperator-listesi',
                                    href: '/#/coper/turoperator/index'
                                }, {
                                    title: this.$t('Insurance'),
                                    to: 'coper-sigorta-listesi',
                                    href: '/#/coper/sigorta/index'
                                }, {
                                    title: this.$t('Ferry'),
                                    to: 'coper-feribot-listesi',
                                    href: '/#/coper/feribot/index'
                                }, {
                                    title: 'Golf',
                                    to: 'coper-golf-listesi',
                                    href: '/#/coper/golf/index'
                                }]
                            },
                            {
                                title: this.$t('Reports'),
                                group: 'coperraporlar',
                                items: [{
                                    title: this.$t('Sales-Report'),
                                    to: 'coper-satisraporu',
                                    href: '/#/coper/raporlar/satisraporu'
                                },{
                                    title: this.$t('General-Purpose-Report'),
                                    to: 'coper-genelamaclirapor',
                                    href: '/#/coper/raporlar/genelamaclirapor'
                                }, {
                                    title: this.$t('Profitability-Report'),
                                    to: 'coper-karlilikraporu',
                                    href: '/#/coper/raporlar/karlilikraporu'
                                }, {
                                    title: this.$t('Seller-Payment-Report'),
                                    to: 'coper-odemeraporu',
                                    href: '/#/coper/raporlar/odemeraporu'
                                },{
                                    title: this.$t('Invoices-Received-Not-Received'),
                                    to: 'coper-faturasigelengelmeyenraporu',
                                    href: '/#/coper/raporlar/faturasigelengelmeyen'
                                },
                                {
                                    title: this.$t('Visa-Tracking-List'),
                                    to: 'coper-vizetakiplistesi',
                                    href: '/#/coper/raporlar/vizetakiplistesi'
                                }, 
                                {
                                    title: this.$t('Daily-Tour-List'),
                                    to: 'coper-gunluktur',
                                    href: '/#/coper/raporlar/gunlukturlistesi'
                                }, 
                                ]
                            },
                            {
                                
                                title: 'Coper ' + this.$t('Forms'),
                                group: 'faturaraporlar',
                                items: [ {
                                        title: this.$t('Quotation-Form'),
                                        to: 'coper-kotasyonformu',
                                        params:'islem=yeni',
                                        href: '/#/coper/page/formlar/kotasyonformu/id'
                                    }
                                ]
                            },
                            {
                                title: this.$t('Payments'),
                                group: 'coperodemeler',
                                items: [{
                                        title: this.$t('Seller-Payments'),
                                        to: 'coper-saticiodemeler',
                                        href: '/#/coper/odemeler/saticiodemelistesi'
                                    },
    
                                ]
                            },
                            {
                                title: this.$t('Advertisements'),
                                group: 'copertanitimlar',
                                items: [{
                                        title: 'Parametreler',
                                        to: 'coper-tanitimlar-parametrelist',
                                        href: '/#/coper/tanitimlar/parametreler'
                                    },
                                    {
                                        title: 'Adresler',
                                        to: 'coper-adreslistesi',
                                        href: '/#/coper/tanitimlar/adreslistesi'
                                    },
                                    {
                                        title: this.$t('Hotel-List'),
                                        to: 'coper-tanitimlar-otellistesi',
                                        href: '/#/coper/tanitimlar/Otellistesi/otellistesi'
                                    },
                                    {
                                        title: this.$t('Collection'),
                                        to: 'coper-odemelistesi',
                                        href: '/#/coper/tanitimlar/odeme'
                                    },
                                    {
                                        title: this.$t('Agency-Commission'),
                                        to: 'coper-tanitimlar-acentekomisyon',
                                        href: '/#/coper/tanitimlar/acentekomisyon'
                                    }, {
                                        title: this.$t('Profitability'),
                                        to: 'coper-tanitimlar-karlilik',
                                        href: '/#/coper/tanitimlar/karlilik'
                                    },
                                    {
                                        title: this.$t('Visa-Price'),
                                        to: 'coper-tanitimlar-vizefiyatlist',
                                        href: '/#/coper/tanitimlar/vizefiyat/index'
                                    },
                                    {
                                        title: 'Otel Kategori',
                                        to: 'coper-otelkategori',
                                        href: '/#/coper/tanitimlar/otelkategori'
                                    },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'coperaktarimlar',
                                items: [{
                                        title: 'Bizitravel',
                                        to: 'coper-aktarim-bizitravel',
                                        href: '/#/coper/aktarim/bizitravel'
                                    },
                                    {
                                        title: 'Booking Agora',
                                        to: 'coper-aktarim-bookingagora',
                                        href: '/#/coper/aktarim/bookingagora'
                                    },
                                ]
                            },
                        ]
                    },
                   
                    {
                                icon: 'account_balance',
                                title: 'Resmi Muhasebe',
                                group: 'muhasebe',
                                color: 'blue darken-2',
                               
                                items: [
                                    {
                                        title: 'Muhasebe Kod Listesi',
                                        to: 'muhasebe-muhasebekodlari',
                                        href: '/#/muhasebe/muhasebekodlari/liste'
                                    },
                                    {
                                         title: 'Fis Listesi',
                                         to: 'muhasebe-fisler-liste',
                                         href: '/#/muhasebe/fisler/liste'
                                        },
                                        {
                                         title: 'Tevkifat Bağlantıları',
                                         to: 'muhasebe-tevkifat-baglanti',
                                         href: '/#/muhasebe/muhasebekodlari/tevkifatbaglanti'
                                        },
                                        {
                                        title: 'Raporlar',
                                        group: 'muhaseberaporlar',
                                        items: [
                                            {
                                                title: 'Ekstreler',
                                                group: 'mhekstreler',
                                                items :[
                                                {    
                                        title: 'Hesap Ekstresi',
                                        to: 'muhasebe-rapor-hesap',
                                        href: '/#/muhasebe/raporlar/hesabagore'
                                        },
                                        {    
                                        title: 'Referans Ekstresi',
                                        to: 'muhasebe-rapor-referans',
                                        href: '/#/muhasebe/raporlar/referansagore'
                                        },
                                       
                                                ]
                                            },
                                       {
                                        title: 'Mizanlar',
                                        group: 'mhmizanlar',
                                        items: [
                                        {
                                        title: this.$t('Accounting-Balance'),
                                        to: 'muhasebe-rapor-mizan',
                                        href: '/#/muhasebe/raporlar/mizan'
                                        },
                                        {
                                        title: 'Referansa Göre Mizan',
                                        to: 'muhasebe-referans-mizan',
                                        href: '/#/muhasebe/raporlar/referansmizan'
                                        },
                                        ]
                                       },
                                       {
                                        title: 'Bilanço',
                                        group: 'mhbilanco',
                                        items: [
                                        {
                                        title: 'Bilanço Formatı',
                                        to: 'muhasebe-rapor-bilancoformat',
                                        href: '/#/muhasebe/raporlar/mizan'
                                        },
                                        {
                                        title: 'Bilanço Raporu',
                                        to: 'muhasebe-rapor-bilancorapor',
                                        href: '/#/muhasebe/raporlar/referansmizan'
                                        },
                                        ]
                                       },
                                       {
                                        title: 'Gelir-Gider',
                                        group: 'mhgelirgider',
                                        items: [
                                        {
                                        title: 'Gelir-Gider Formatı',
                                        to: 'muhasebe-rapor-gelirgiderformat',
                                        href: '/#/muhasebe/raporlar/gelirgiderformat'
                                        },
                                        {
                                        title: 'Gelir-Gider Tablosu',
                                        to: 'muhasebe-rapor-gelirgiderrapor',
                                        href: '/#/muhasebe/raporlar/gelirgiderrapor'
                                        },
                                        ]
                                       },
                                       {    
                                        title: 'Borç Yaşlandırma',
                                        to: 'muhasebe-rapor-borcyaslandirma',
                                        href: '/#/muhasebe/raporlar/borcyaslandirma'
                                        },
                                        {    
                                        title: 'Alacak Yaşlandırma',
                                        to: 'muhasebe-rapor-alacakyaslandirma',
                                        href: '/#/muhasebe/raporlar/alacakyaslandirma'
                                        },
                                       {
                                        title: 'Muhasebe Yekun Kontrolü' ,
                                        to: 'muhasebe-rapor-yekunkontrolu',
                                        href: '/#/muhasebe/raporlar/mizan'
                                        }

                                        ]
                                    },
                                    {
                                        title: 'Resmi Defterler',
                                        group: 'muhaseberesmidefterler',
                                        items: [
                                        {
                                        title: "Mükerrer Fiş No Kontrol",
                                        to: 'muhasebe-resmidefter-mukerrerfiskontrol',
                                        href: '/#/muhasebe/resmidefter/mukerrerfiskontrol'
                                        },
                                        {
                                        title: "E-Defter Schematron Kontrolü",
                                        to: 'muhasebe-resmidefter-schematronkontrol',
                                        href: '/#/muhasebe/resmidefter/schematronkontrol'
                                        },
                                        {
                                        title: this.$t('Create-Ledger'),
                                        to: 'muhasebe-resmidefter-defterolustur',
                                        href: '/#/muhasebe/raporlar/defterolustur'
                                        },{
                                        title: this.$t('Delete-Ledger'),
                                        to: 'muhasebe-resmidefter-deftersil',
                                        href: '/#/muhasebe/raporlar/deftersil'
                                        },
                                        {
                                        title: 'E-Defter',
                                        to: 'muhasebe-edefter-edefterexport',
                                        href: '/#/muhasebe/edefter/edefterexport'
                                    }, 
    
                                            ]
                                     },
                                     {
                                        title: 'Entegrasyon',
                                        group: 'muhasebeentegrasyon',
                                        items: [{
                                        title: 'Bilet',
                                        group: 'biletentegrasyon',
                                        items: [{
                                                title: 'Şablon Girişi',
                                                to: 'muhasebe-entegrasyon-bilet',
                                                href: '/#/entegrasyon/biletent'
                                                },
                                                {
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-bilet-entegre',
                                                href: '/#/entegrasyon/biletentegre'
                                                }
                                        ]
                                        },{
                                        title: 'Cari Hareket',
                                        group: 'carihareketent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-carihareket',
                                                href: '/#/entegrasyon/carihareket/carient'
                                                }
                                        ]
                                        },{
                                        title: this.$t('Free-Invoice'),
                                        group: 'serbestfaturaent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-serbestfatura-entegre',
                                                href: '/#/entegrasyon/serbestfatura/serbestent'
                                                }
                                        ]
                                        },{
                                        title: 'Coper',
                                        group: 'coperent',
                                        items: [{
                                                title: this.$t('Integration-v2'),
                                                to: 'muhasebe-entegrasyon-coper',
                                                href: '/#/entegrasyon/coperentegre'
                                                }
                                        ]
                                        },
                                        
                                        ]
                                      
                                    },
                                    {
                                        title: this.$t('Definitions-v2'),
                                        to: 'muhasebe-tanimlamalar',
                                        href: '/#/muhasebe/tanimlamalar'
                                    },
                                    {
                                        title: this.$t('Helpers'),
                                        to: 'muhasebe-yardimcilar',
                                        href: '/#/muhasebe/yardimcilar/index'
                                    },
                                    {
                                        title: this.$t('Parameters'),
                                        to: 'muhasebe-parametreler',
                                        href: '/#/muhasebe/parametreler'
                                    },
                                   
                                ]
                    },
                      
                        {
                        icon: 'inventory',
                        title: this.$t('Visa-Procedures'),
                        to: 'coper-vize-yeni',
                        href: '/#/coper/vize/yeni/id?islem=yeni'
                        },
                        {
                        icon: 'receipt',
                        title: this.$t('Bills'),
                        group: 'faturalar',
                        color: 'blue darken-2',
                        items: [{
                                title: this.$t('Sales-Invoice-List'),
                                to: 'faturalistesi',
                                href: '/#/fatura/faturalistesi'
                            }, {
                                title: this.$t('List-of-Invoices-Received'),
                                to: 'gelenfaturalistesi',
                                href: '/#/fatura/gelenfaturalistesi'
                            },
                            {
                                title: this.$t('Ticket-Self-invoice'),
                                to: 'fatura-basma',
                                href: '/#/fatura/faturabasma'
                            },
                             {
                                title: 'E-Fatura (BETA)',
                                group: 'coper-e-faturalar',
                                items: [ {
                                title: "Gelen Fatura Listesi",
                                to: 'fatura-EFaturaListesi',
                                href: '/#/fatura/gelenEFaturaListesi'
                                },{
                                title: this.$t('Save-Received-E-Invoices-Archive'),
                                to: 'fatura-EFaturalariHavuzaKaydet',
                                href: '/#/fatura/gelenEFaturalariHavuzaKaydet'
                                },{
                                title: this.$t('Invoice-Status-Query'),
                                to: 'faturasorgula',
                                href: '/#/fatura/faturadurumsorgula'
                                },
                                ]
                            },
                             {
                                title: 'Coper',
                                group: 'coperfaturalar',
                                items: [ {
                                title: this.$t('Bulk-Invoice'),
                                to: 'fatura-copertoplufaturalistesi',
                                href: '/#/fatura/copertoplufatura'
                                },{
                                title: this.$t('Invoice-Received'),
                                to: 'coper-gelenfaturalistesi',
                                href: '/#/coper/page/formlar/gelenfaturalistesi'
                                },{
                                title: this.$t('Commission-Invoice'),
                                to: 'coper-komisyonfaturasi',
                                href: '/#/coper/komisyonfaturasi/index'
                                }, {
                                title: this.$t('Sales-Return-Invoice-List'),
                                to: 'fatura-coper-satisiade',
                                href: '/#/fatura/copersatisiade'
                                },
                                ]
                            },
                            {
                                title: this.$t('Transfers'),
                                group: 'aktarimlar',
                                items: [{
                                    title: this.$t('Free-Invoice-Transfers'),
                                    to: 'fatura-aktarimlar-serbestfatura',
                                    href: '/#/fatura/aktarimlar/serbestfaturaexcel'
                                }, 
                                ]
                            },
                            {
                                title: this.$t('Definitions-v2'),
                                to: 'faturatanimlamalar',
                                href: '/#/fatura/tanimlamalar'
                            }, {
                                title: this.$t('Settings'),
                                to: 'faturaayarlar',
                                href: '/#/fatura/ayarlar'
                            },
                            // {
                            //     title: 'Satış Fatura Entegrasyonu',
                            //     to: 'faturaentegrasyon',
                            //     href: '/#/fatura/faturaentegrasyon'
                            // },
    
                        ]
    
                    },
                  {
                       icon: 'business',
                       title: this.$t('Market-Place-Beta'),
                       group: 'satis',
                       color: 'blue darken-2',
                       items: [   
                            {
                               icon:'hotel',
                               title: 'Hotel Runner',
                               group: 'runner',
                               items: [{
                               icon: 'maps_home_work',
                               title:  this.$t('Hotel'),
                               to: 'satis-hotelrunner',
                               params: 'isl=hryeni',
                               href: '/#/hotelrunner/index',
                               },{
                               icon: 'maps_home_work',
                               title:  this.$t('Hotel-List'),
                               to: 'satis-hotelrunner-list',
                               href: '/#/hotelrunner/oteltanitim/list',
                               }
                               ]
                           },
                           {
                               icon: 'directions_bus',
                               title: this.$t('Transfer-v4'),
                               to: 'satis-paxdrive',
                               params: 'islemTipi=pdyeni',
                               href: '/#/coper/paxdrive/index/id'
                           },
                           {
                               icon:'flight',
                               title: this.$t('Flight'),
                               group: 'ucus',
                               items: [{
                                   title: 'Uçuş Ara',
                                   to: 'satis-ucus-liste',
                                   href: '/#/satis/ucak/index'
                               }, {
                                   title:  this.$t('Reservation-List'),
                                   to: 'satis-ucus-rezliste',
                                   href: '/#/satis/ucak/rezervasyonliste'
                               },
                               ]
                           },]
                   }, 
                //   {
                //        icon: 'tab',
                //       title: 'Paket Tur',
                //        group: 'pakettur',
                //       color: 'blue darken-2',
                //       items: [   
                //          {
                //              icon: 'directions_bus',
                //              title: 'Master Paketler',
                //               to: 'masterpaket',
                //           href: '/#/pakettur/masterpaket'
                //            },
                //            {
                //               icon: 'directions_bus',
                //               title: 'Alt Paketler',
                //               to: 'turaltpaket',
                //               href: '/#/pakettur/turaltpaket'
                //            },
                //            {
                //              icon: 'directions_bus',
                //              title: 'Tur Ara',
                //              to: 'turara',
                //              href: '/#/pakettur/turara'
                //            },
                //         ]
                //    }, 
                {
                        icon: 'explicit',
                        title: this.$t('Integration'),
                        to: 'entegrasyon-index',
                        href: '/#/entegrasyon/index'
                    },
                    {
                        icon: 'widgets',
                        title: this.$t('Additional-Products'),
                        to: 'ek-urunler',
                        href: '/#/urunler/ekurunler'
    
                    },
                    {
                        icon: 'cloud_download',
                        title: 'Next ' + this.$t('Upload-Ticket'),
                        color: 'blue darken-2',
                        to: 'download-page',
                        href: '/#/download/index'
                    },
                     {
                        icon: 'help',
                        title: this.$t('Help'),
                        to: 'yardim',
                        href: '/#/diger/yardim'
                    },
    
                ],
    
                items3: [{
                        icon: 'home',
                        title: 'Home Page',
                        to: 'home',
                        href: '/#/'
                    },
    
                    {
                        icon: 'attach_money',
                        title: 'Girokonto',
                        group: 'cari',
                        color: 'blue darken-2',
                        items: [{
                                title: 'Girokonto',
                                to: 'cari-index',
                                href: '/#/cari/index'
                            },
                            {
                                title: 'Aktuelle Bewegung',
                                to: 'carihareketler-index',
                                href: '/#/carihareketler/index'
                            },
                            {
                                title: 'Rechnungen',
                                group: 'faturalar',
                                namespace: 'faturalar',
                                items: [{
                                        title: 'Rechnungs Liste',
                                        to: 'fatura-listesi',
                                        href: '/#/faturalar/faturalistesi'
                                    },
                                    {
                                        title: 'Rechnung Schreiben',
                                        to: 'fatura-basma',
                                        href: '/#/faturalar/faturabasma'
                                    }
                                ]
                            },
                            {
                                title: 'Extrakte',
                                group: 'ekstreler',
                                namespace: 'cari',
                                items: [{
                                        title: 'Konto Extrakt',
                                        to: 'ekstre-hesap',
                                        href: '/#/ekstreler/hesabagore'
                                    },
                                    {
                                        title: 'Nach Datum Extrahieren',
                                        to: 'ekstre-tarih',
                                        href: '/#/ekstreler/tarihegore'
                                    },
                                    {
                                        title: 'Nach Referenz Extrahieren',
                                        to: 'ekstre-referans',
                                        href: '/#/ekstreler/referansagore'
                                    },
                                    {
                                        title: 'Nach Ausgabe Extrahieren',
                                        to: 'ekstre-masraf',
                                        href: '/#/ekstreler/masrafmerkezinegore'
                                    },
                                    {
                                        title: 'Nach Karte Extrahieren',
                                        to: 'ekstre-firmakart',
                                        href: '/#/ekstreler/firkakartinagore'
    
                                    },
                                ]
                            },
                            {
                                title: 'Rohbilanz',
                                group: 'mizanlar',
                                namespace: 'mizan',
                                items: [{
                                        title: 'Nach Strom Rohbilanz',
                                        to: 'mizan-carihesap',
                                        href: '/#/mizan/carihesap'
                                    },
                                    {
                                        title: 'Nach die Devise Rohbilanz',
                                        to: 'mizan-doviz',
                                        href: '/#/mizan/doviz'
                                    },
                                    {
                                        title: 'Nach Ausgabe Rohbilanz',
                                        to: 'mizan-masrafmerkezi',
                                        href: '/#/mizan/masrafmerkezi'
                                    },
                                    {
                                        title: 'Nach Referenz Rohbilanz',
                                        to: 'mizan-referans',
                                        href: '/#/mizan/referans'
                                    }
                                ],
                            },
                            {
                                title: 'Andere',
                                group: 'diger',
                                items: [{
                                        title: 'Debitor- und Gläubigerliste',
                                        to: 'borclu-liste',
                                        href: '#/diger/borclulistesi'
                                    },
                                    {
                                        title: 'Cash-Bericht',
                                        to: 'kasa-liste',
                                        href: '#/diger/kasaraporu'
                                    }
                                ]
                            },
                            {
                                title: 'Definitionen',
                                to: 'genelparametreler',
                                href: '/#/parametreler/genel'
                            },
                            {
                                title: 'Parameter',
                                grup: 'genelparametre',
                                items: [{
                                        title: 'Girokonto General ',
                                        to: 'parametre-genel',
                                        href: '#/tanimlamalar/genel'
                                    },
                                    {
                                        title: 'Unternehmens Parameter',
                                        to: 'parametre-sirket',
                                        href: '#/tanimlamalar/sirket'
                                    }
                                ]
                            },
                            {
                                title: 'Extras',
                                grup: 'ekstralar',
                                items: [{
                                    title: this.$t('Customer-Personnel-Entry'),
                                    to: 'ekstra-musteri',
                                    href: '#/ekstralar/musteri-personel'
                                }, {
                                    title: this.$t('Profile-Template-Design'),
                                    to: 'ekstralar-profilsablon',
                                    href: '#/ekstralar/profilsablon'
                                }, {
                                    title: this.$t('Template-Data-Entry'),
                                    to: 'ekstralar-verigirisi',
                                    href: '#/ekstralar/sablonverigirisi'
                                }]
                            }
                        ]
    
                    },
                    {
                        icon: 'flight_takeoff',
                        title: 'Ticket',
                        group: 'bilet',
                        color: 'blue darken-2',
                        items: [{
                                title: 'Ticket Liste',
                                to: 'bilet-listesi',
                                href: '/#/bilet/index'
                            },
                            // {
                            //     title: 'Bilet Alış Fatura Entegrasyonu',
                            //     to: 'bilet-alis-entegre',
                            //     href: '/#/bilet/indexIntegrate'
                            // }, 
                            {
                                title: 'Definitionen',
                                to: 'bilet-tanimlamalar',
                                href: '/#/bilet/tanimlamalar'
                            }, {
                                title: 'Berichte',
                                to: 'bilet-raporlar',
                                items: [{
                                    title: this.$t('Daily-Sales-Report'),
                                    to: 'bilet-gunluksatisraporu',
                                    href: '/#/bilet/gunluksatisraporu'
                                }, {
                                    title: this.$t('Income-Distribution-Report'),
                                    to: 'bilet-gelirdagilimiraporu',
                                    href: '/#/bilet/gelirdagilimiraporu'
                                }]
                            },
                            {
                                title: 'Ticket Transfer',
                                to: 'bilet-aktarimlar',
                                items: [{
                                    title: 'THY Transfer',
                                    to: 'thy-aktarim',
                                    href: '/#/bilet/aktarimbilet/thyaktarim'
                                }, {
                                    title: 'AMADEUS Transfer',
                                    to: 'amadeus-aktarim',
                                    href: '/#/bilet/aktarimbilet/amadeusaktarim'
                                }, {
                                    title: 'AMADEUS ' + this.$t('Transfer') + '(SFTP)',
                                    to: 'amadeus-aktarimftp',
                                    href: '/#/bilet/aktarimbilet/amadeusaktarimftp'
                                }, {
                                    title: 'PEGASUS Transfer',
                                    to: 'pegasusaktar',
                                    href: '/#/bilet/aktarimbilet/pegasusaktarim'
                                }, 
                                {
                                    title: 'PEGASUS Online Aktarım',
                                    to: 'pegasusonlineaktar',
                                    href: '/#/bilet/aktarimbilet/pegasusonlineaktarim'
                                }, 
                                {
                                        title: 'AJET Excel ' + this.$t('Transfer'),
                                        to: 'ajetaktar',
                                        href: '/#/bilet/aktarimbilet/ajetaktarim'
                                    }, 
                                    {
                                        title: 'AJET Xml ' + this.$t('Transfer'),
                                        to: 'ajetaktarimxml',
                                        href: '/#/bilet/aktarimbilet/ajetaktarimxml'
                                    }, 
                                {
                                    title: 'ONUR AIR Transfer',
                                    to: 'onurairaktar',
                                    href: '/#/bilet/aktarimbilet/onurairaktar'
                                }, {
                                    title: 'IATI Transfer',
                                    to: 'iatiaktar',
                                    href: '/#/bilet/aktarimbilet/iatiaktar'
                                }, {
                                    title: 'SUNEXPRESS Transfer',
                                    to: 'sunexpressaktar',
                                    href: '/#/bilet/aktarimbilet/sunexpressaktar'
                                },{
                                        title: 'THY XML ' + this.$t('Transfer'),
                                        to: 'thy-aktarim-xml',
                                        href: '/#/bilet/biletaktarim/thyaktarimxml'
                                }
                                ]
                            }
                        ]
                    }
    
                    // //Coper başla
                    // {
                    //   icon: 'hotel',
                    //   title: 'Coper',
                    //   group: 'coper',
                    //   color: 'blue darken-2',
                    //   items: [{
                    //       title: 'Saticilar',
                    //       to: 'saticilist',
                    //       href: '/#/coper/saticilist'
                    //     },
                    //     {
                    //       title: 'Saticilar (Yeni)',
                    //       to: 'saticilar',
                    //       href: '/#/coper/saticilar'
                    //     },
                    //     {
                    //       title: 'Rezervasyon',
                    //       to: 'rezervasyonyeni',
                    //       href: '/#/coper/rezervasyonyeni'
                    //     },
                    //     {
                    //       title: 'Sirketler',
                    //       to: 'coperSirket',
                    //       href: '/#/coper/coperSirket'
                    //     },
    
                    //   ]
    
                    // },
                    //Coper Bitiş
    
                    //EFatura başla
                    // {
                    //   icon: 'book',
                    //   title: 'EFatura',
                    //   group: 'EFatura',
                    //   color: 'blue darken-2',
                    //   items: [{
                    //       title: 'EFatura',
                    //       to: 'efatura',
                    //       href: '/#/efatura/efatura'
                    //     },
    
                    //   ]
    
                    // },
                    // {
                    //   icon: 'power_settings_new',
                    //   title: 'Çıkış',
                    //  // to: 'logout()',
                    //   //href: '/#/login'
                    // }
                    // //EFatura Bitiş
    
                ],
    
                Sirket: {
                    SirketUnvani: '',
                    SirketKodu: '',
                    SirketAdi: '',
                    AnaSirketKodu: ''
                },
                Sirketler: [],
                Sirketler1: [],
                CoperSirketler: [],
                CoperSirketAdi: null,
                MuhasebeSirketler:[],
                MuhasebeSirketNo:null,
                MuhasebeSirketAdi:null,
                dialog: false,
                yedek: {
                    aa: '',
                    bb: '',
                    cc: ''
                },
               checkCred: null,
            }
    
        },
    
        created: function () {
            this.dialogoturum = false;
            this.timer = setInterval(this.fetchEventsList, 10000);
            this.checkCred = JSON.parse(window.localStorage.getItem("response"));
        },
    
        computed: {
            supportedLanguages() {
                return Trans.supportedLanguages
            },
            currentLanguage() {
                return Trans.currentLanguage
            }
        },
        beforeMount: beforeMount,
        updated: function () {
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });
    
        },
    
        watch: {},
        methods: {
            RemoveIntegrations(InvoiceIntegration3rd)
            {
               
                if (!InvoiceIntegration3rd || InvoiceIntegration3rd)
{
    for(var i = 0; i < this.items.length; i++) {
    if(this.items[i].group == 'bilet') {
        for(var g = 0; g < this.items[i].items.length; g++) {
    if(this.items[i].items[g].to == 'bilet-alis-entegre') {
        this.items[i].items.splice(g, 1);
        break;
    }
}
       
    }
}


for(var i = 0; i < this.items2.length; i++) {
    if(this.items2[i].group == 'bilet') {
        for(var g = 0; g < this.items2[i].items.length; g++) {
    if(this.items2[i].items[g].to == 'bilet-alis-entegre') {
        this.items2[i].items.splice(g, 1);
        break;
    }
}
       
    }
}

for(var i = 0; i < this.items.length; i++) {
    if(this.items[i].group == 'faturalar') {
        for(var g = 0; g < this.items[i].items.length; g++) {
    if(this.items[i].items[g].to == 'faturaentegrasyon') {
        this.items[i].items.splice(g, 1);
        break;
    }
}
       
    }
}


for(var i = 0; i < this.items2.length; i++) {
    if(this.items2[i].group == 'faturalar') {
        for(var g = 0; g < this.items2[i].items.length; g++) {
    if(this.items2[i].items[g].to == 'faturaentegrasyon') {
        this.items2[i].items.splice(g, 1);
        break;
    }
}
       
    }
}

}
            },
            GetVersion(){
        this.$http.post(auth.API_URL + 'api/AccountingDefinitions/VersionDate', '', {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                     
    this.versiondate=response.body.VerDateStr;
                      
    
                    }, (response) => {
                       
                    })
    },
            MuhasebeSirketCheck(url)
            {
                this.dialogMuhasebeUyari=true;
                // var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
                // if (credentials1.MuhasebeSirketNo==null || credentials1.MuhasebeSirketNo=='' || credentials1.MuhasebeSirketNo=='undefined')
                // {
                    
                // }
                // else
                // {
                    
                //     this.$router.push({path: url}).catch((e) => e);
                // }
    
       
            },
            yardimciIslemAc()
            {
                this.$refs.yardimciIslemDialog.open();
                
            },
            urunDetayAc() {
                this.$refs.kontorlerDialog.open();
            },
            getLink() {
                this.$refs.musteriraporlink.open().then(sonuc => {});
    
            },
    
            gizlilikSozlesme() {
                this.$refs.gizlilikSozlesme.open().then(sonuc => {});
            },
            aydinlatmaSozlesme() {
                this.$refs.aydinlatmaSozlesme.open().then(sonuc => {});
            },
            versiyonlarGonder() {
                router.push({
                    path: 'versiyonlar/index'
                })
            },
            dialogMesajAc() {
                var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
                this.MesajTel = ml.UserInfo.GSM
                this.MesajAd = ml.UserInfo.AdSoyad
                this.MesajSonuc = null
                this.MesajAciklama = null
                this.dialogmesaj = !this.dialogmesaj
            },
            mesajGonder() {
                if (this.$refs.formmesaj.validate()) {
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                    var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
    
                    var mesajparams = {
                        MusteriBilgi: {
                            MusteriID: credentials.MusteriID,
                            MusteriKod: credentials.AnaSirketKodu,
                            MusteriAdi: null,
                        },
                        UserBilgi: {
                            UserID: ml.UserInfo.UserID,
                            Email: ml.UserInfo.Email,
                            AdSoyad: ml.UserInfo.AdSoyad,
                        },
                        AlisTarihi: helpers.getDateNow(),
                        Arayan: ml.UserInfo.AdSoyad,
                        ArayanMail: ml.UserInfo.Email,
                        Cozuldu: false,
                        CozecekBilgi: {
                            UserID: 300,
                            Email: 'destek@arkman.com.tr',
                            AdSoyad: null,
                        },
                        BeklenenYer: {
                            Id: null,
                            ParentId: null,
                            Aciklama: null,
                            Yetki: null,
                        },
                        UrunBilgi: {
                            Ref: null,
                            UrunAdi: null,
                            UrunAciklama: 'Next',
                            Aciklama: 'Web üzerinden gelen sorun talepler',
                        },
                        SorunAciklama: this.MesajAciklama,
                        SorunTip: {
                            SorunTipID: 72,
                            Aciklama: 'Arkman Next Sorun Talep',
                        }
                    }
    
                    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', mesajparams, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
    
                        if (response.body.Status == true) {
                            this.MesajSonuc = 'Mesajınız gönderildi. Talep Numaranız: ' + response.body.SaveID
                            this.epostagonder(mesajparams, response.body.SaveID);
    
                        } else {
                            this.MesajSonuc = 'Mesajınız gönderilemedi, tekrar deneyiniz.'
                        }
    
                    }, (response) => {
                        if (response.status === 0) {
                            this.MesajSonuc = 'Mesajınız gönderilemedi, tekrar deneyiniz.'
    
                        } else {
                            this.MesajSonuc = 'Mesajınız gönderilemedi, tekrar deneyiniz.'
    
                        }
                    })
    
                }
            },
            epostagonder(info, talepNo) {
    
                let formData = new FormData();
    
                formData.append('Konu', 'Arkman Next Hata/Öneri')
                formData.append('to', 'destek@arkman.com.tr')
                formData.append('mailType', '1')
                formData.append('TalepNo', talepNo)
                formData.append('MusteriKodu', info.MusteriBilgi.MusteriKod)
                formData.append('Mesaj', info.SorunAciklama)
                formData.append('Email', info.UserBilgi.Email)
                formData.append('Tel', this.MesajTel)
                formData.append('AdSoyad', this.MesajAd)
                axios.defaults.baseURL = auth.API_URL;
                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                axios.post(auth.API_URL + 'api/Helpers/SendEmail',
                        formData, {
                            headers: {
    
                            }
                        }
                    ).then((response) => {
    
                        if (response.data == true) {
                            // this.text1 =
                            //   "Sistemde kayıtlı mail adresinize onay maili gönderilmiştir. Mailinizi onaylayarak giriş yapabilirsiniz."
                            // this.snackbar = true
                        } else {
                            // this.text1 = this.$t('Your-user-record-has-been-created-approval-mail-has-not-been-sent-your-mail')
                            // this.snackbar = true
                        }
                    })
                    .catch(function () {});
    
            },
            clinistaCheck(sayfaAd) {
                if (sayfaAd === "coper-clinistaliste" || sayfaAd === "coper-clinistaislem") {
                    return false
                } else {
                    return true
                }
    
            },
            sayfaCheck(sayfa) {
                
                if(sayfa === "yardimci-islemler-muhasebekodupdate") {
                    return 2
                } else if(sayfa.indexOf('coper') != -1) {
                    return 0
                } else if(sayfa.indexOf('muhasebe') != -1){
                    return 1
                }else {
                    return 2
                }
            },
            muhasebesirketbilgilerinial(cred){
                
                
                if (cred.MuhasebeSirketUnvan != null) {
                    this.MuhasebeSirketNo=cred.MuhasebeSirketNo;
                   this.MuhasebeSirketAdi=cred.MuhasebeSirketAdi ;
                    
                } else {
                    this.MuhasebeSirketNo=null;
                    this.MuhasebeSirketAdi = 'Tanımlı sirket bulunamadı'
                }
    
                if (cred.MuhasebeSirketler != null && cred.MuhasebeSirketler != [] && cred.MuhasebeSirketler != 'undefined') {
                    this.MuhasebeSirketler = cred.MuhasebeSirketler
                } else {}
            },
            copersirketbilgilerinial(cred) {
                if (cred.CoperSirketUnvan != null) {
                    this.CoperSirketAdi =  cred.CoperSirketAdi
                } else {
                    this.CoperSirketAdi = 'Tanımlı sirket bulunamadı'
                }
    
                if (cred.CoperSirketler != null && cred.CoperSirketler != [] && cred.CoperSirketler != 'undefined') {
                    this.CoperSirketler = cred.CoperSirketler
                } else {}
    
            },
            open(a) {
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
    
            },
            fetchEventsList: function () {
    
                this.dialogoturum = false
    
                var token = window.localStorage.getItem('token');
    
                if (token != null) {
                    var decoded = jwt_decode(token);
                    const exptime = new Date(0);
                    exptime.setUTCSeconds(decoded.exp);
                    var today = null;
                    today = new Date();
                    var songecer = new Date(exptime)
    
                    if (songecer > today) {
                        this.dialogoturum = false
    
                    } else {
                        this.dialogoturum = true
                        clearInterval(this.timer);
                    }
    
                } else {
                    this.dialogoturum = true
                }
            },
    
            borcluListesi() {
                var url = '#/diger/borclulistesi/'
                window.open(url, '_self')
            },
    
            kullaniciyagit() {
                var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
    
                var url = '#/uye/detay/' + manageload.UserInfo.Email
                window.open(url, '_self')
            },
            anasirketleregit() {
                var url = '#/anasirket'
                window.open(url, '_self')
            },
            sirketgetir() {
                this.Sirketler1 = this.Sirketler
            },
            changeLanguage(e) {
                localStorage.setItem( "lang", e )
                
                // tum sayfalarda eklenene kadar sayfa kontrollu yeniden yukleme yapilacak.
                if(this.$route.name == "bilet-listesi" || this.$route.name == "bilet-yeni" || this.$route.name == "bilet-bspdevreraporu" || this.$route.name == "genelamaclirapor"){
                    this.$root.$i18n.locale = e;
                }else{
                   location.reload();
                }
                
            },
            isCurrentLanguage(lang) {
                return lang === this.currentLanguage
            },
            getImgUrl(pet) {
                var images = require.context('./assets/images', false, /\.png$/)
                return images('./' + pet + ".png")
            },
            switchLocale: function () {
            },
            getChildTarget(item, subItem) {
                if (subItem.href) return
                if (item.component) {
                    return {
                        name: item.component,
                        params: {
                            section: item.group,
                            component: subItem.name
                        }
                    }
                }
                return {
                    name: `${item.group}/${subItem.name}`
                }
            },
            logout() {
                this.snackbarlogin = false
                this.dialogoturum = false;
                auth.logout()
    
            },
    
            sirketdegistir: sirketdegistir,
            degistir: degistir,
            copersirketdegistir,
            muhasebesirketdegistir,
            coperdegistir,
            muhasebedegistir
           
        },
        filters: {
    dateformat: function (t) {
    return helpers.dateformat(t);
    }
    },
        components: {
            'TheLanguageSwitcher': TheLanguageSwitcher,
            gizlilikSozlesme,
            aydinlatmaSozlesme,
            musteriraporlink,
            kontorlerDialog,
            yardimciIslemDialog
        },
        beforeUpdate: beforeUpdate,
        mounted: beforeUpdate,
        name: 'App'
    }
    
    function sirketdegistir(item, islemtip) {
    
        this.islemtip = islemtip
    
        if (this.Sirket.SirketKodu != item.SirketKodu) {
            this.dialog = true
            this.yedek.aa = item.SirketKodu
            this.yedek.bb = item.SirketAdi
            this.yedek.cc = item.SirketUnvani
        }
    
    }
    
    function copersirketdegistir(item, islemtip) {
        this.islemtip = islemtip
    
        var cred = JSON.parse(window.localStorage.getItem('credentials'));
    
        this.YeniCoperSirketAdi = item.SirketKod
        this.YeniCoperSirketUnvani = item.SirketIsmi
        this.YeniCoperSirketNo = item.SirketNo
    
        if (cred.CoperSirketNo != item.SirketNo) {
            this.dialog = true
        }
    
    }
    function muhasebesirketdegistir(item,islemtip){
        this.islemtip = islemtip
        var cred = JSON.parse(window.localStorage.getItem('credentials'));
    
        this.YeniMuhasebeSirketAdi = item.CompanyShortName 
        this.YeniMuhasebeSirketUnvani = item.CompanyLongName
        this.YeniMuhasebeSirketNo = item.CompanyID
    
        if (cred.MuhasebeSirketNo != item.CompanyID) {
            this.dialog = true
        }
    }
    
    function degistir() {
        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
        this.dialog = false
    
        var credentials = {
            AnaSirketKodu: this.Sirket.AnaSirketKodu,
            SirketKodu: this.yedek.aa,
            SirketAdi: this.yedek.bb,
            SirketUnvani: this.yedek.cc,
            Sirketler: credentials1.Sirketler,
            EArsiv: credentials1.EArsiv,
            EFatura: credentials1.EFatura,
            CoperSirketler: credentials1.CoperSirketler,
            CoperSirketNo: credentials1.CoperSirketNo,
            CoperSirketAdi: credentials1.CoperSirketAdi,
            CoperSirketUnvan: credentials1.CoperSirketUnvan,
            MuhasebeSirketler: credentials1.MuhasebeSirketler,
            MuhasebeSirketNo: credentials1.MuhasebeSirketNo,
            MuhasebeSirketAdi: credentials1.MuhasebeSirketAdi,
            MuhasebeSirketUnvan: credentials1.MuhasebeSirketUnvan,
            MusteriID: credentials1.MusteriID,
            UserID: credentials1.UserID,
            ParaBirimi: credentials1.ParaBirimi
        }
    
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
    
        //ana şirketleri alıyoruz
    
        var response1 = JSON.parse(window.localStorage.getItem('response'));
    
        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.
    
        var userparams = {
            Email: response1.Email
        }
    
        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
    
            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
    
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    
        router.push({
            path: '/'
        })
    
    }
    
    function coperdegistir() {
        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
        this.dialog = false
        var credentials = {
            AnaSirketKodu: credentials1.AnaSirketKodu,
            SirketKodu: credentials1.SirketKodu,
            SirketAdi: credentials1.SirketAdi,
            SirketUnvani: credentials1.SirketUnvani,
            Sirketler: credentials1.Sirketler,
            EArsiv: credentials1.EArsiv,
            EFatura: credentials1.EFatura,
            CoperSirketler: credentials1.CoperSirketler,
            CoperSirketNo: this.YeniCoperSirketNo,
            CoperSirketAdi: this.YeniCoperSirketAdi,
            CoperSirketUnvan: this.YeniCoperSirketUnvani,
            MuhasebeSirketler: credentials1.MuhasebeSirketler,
            MuhasebeSirketNo: credentials1.MuhasebeSirketNo,
            MuhasebeSirketAdi: credentials1.MuhasebeSirketAdi,
            MuhasebeSirketUnvan: credentials1.MuhasebeSirketUnvan,
            MusteriID: credentials1.MusteriID,
            UserID: credentials1.UserID,
            ParaBirimi: credentials1.ParaBirimi
        }
    
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
        router.push({
            path: '/'
        })
    
        //router.push({path: '/'})
    
    }
    
    function muhasebedegistir(){
        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
        this.dialog = false
        var credentials = {
            AnaSirketKodu: credentials1.AnaSirketKodu,
            SirketKodu: credentials1.SirketKodu,
            SirketAdi: credentials1.SirketAdi,
            SirketUnvani: credentials1.SirketUnvani,
            Sirketler: credentials1.Sirketler,
            EArsiv: credentials1.EArsiv,
            EFatura: credentials1.EFatura,
            CoperSirketler: credentials1.CoperSirketler,
            CoperSirketNo: credentials1.CoperSirketNo,
            CoperSirketAdi: credentials1.CoperSirketAdi,
            CoperSirketUnvan: credentials1.CoperSirketUnvan,
            MuhasebeSirketler: credentials1.MuhasebeSirketler,
            MuhasebeSirketNo: this.YeniMuhasebeSirketNo,
            MuhasebeSirketAdi: this.YeniMuhasebeSirketAdi,
            MuhasebeSirketUnvan: this.YeniMuhasebeSirketUnvani,
            MusteriID: credentials1.MusteriID,
            UserID: credentials1.UserID,
            ParaBirimi: credentials1.ParaBirimi
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
        router.push({
            path: '/'
        })
    }
    
    function beforeMount() {
    
        this.dialogoturum = false
        this.fetchEventsList();
        this.GetVersion();
        //girişte dili ayarla ona göre duzenle
        var locale = localStorage.getItem("lang")
        if(locale !== null && locale !== "undefined"){
            this.locale = locale
            this.locales.locale = locale
        }
        else{
            this.locale ='tr'
        }
       
        var params = {}
            this.$http.post(auth.API_URL + 'api/Parameters/Get', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.nextMuhasebe = response.body.NextMuhasebe;
              try {
                // this.RemoveIntegrations(response.body.InvoiceIntegration3rd) ;
}
catch(err) {
  console.log(err);
}
              
            }, (response) => {
              if (response.status === 0) {
                this.text = 'Parametre Service Unavailable'
                this.snackbar = true
    
              } else {
                this.text = 'Parametre Service Unavailable'
                this.snackbar = true
    
              }
            })

            this.uyelikBitisi= localStorage.getItem('uyelikBitisi');
            



    }
   
    function beforeUpdate() {
        
        this.fetchEventsList();
        if (this.versiondate=='')
    {
        this.GetVersion();
    }
        
        
        var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        if (manageload != undefined) {
            this.aktifkullanici = manageload.UserInfo.AdSoyad
    
            if (manageload.UserInfo.DefaultDil == null || manageload.UserInfo.DefaultDil == '') {
    
            } else {
                this.locale = manageload.UserInfo.DefaultDil
            }
        }
    
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB="TRY";
        this.Sirketler = []
    
        if (credentials != null) {
            this.Sirket.SirketUnvani = credentials.SirketUnvani;
            this.Sirket.SirketAdi = credentials.SirketAdi;
            this.Sirket.SirketKodu = credentials.SirketKodu;
            this.Sirket.AnaSirketKodu = credentials.AnaSirketKodu;
    
            for (let index = 0; index < credentials.Sirketler.length; index++) {
                const element = credentials.Sirketler[index];
                if (_.findWhere(this.Sirketler, element) == null) {
                    this.Sirketler.push(element);
                }
    
            }
            this.sirketgetir();
            this.copersirketbilgilerinial(credentials);
            this.muhasebesirketbilgilerinial(credentials);
           
        }
        
    }
    
    </script>
    
    <style>
    
    .v-dialog__content.box {
        align-items: flex-end !important;
        justify-content: flex-end !important;
        padding-bottom: 90px;
        padding-right: 48px;
        position: absolute;
    }
    </style><style lang="stylus">
    @import '../node_modules/vuetify/src/stylus/main.styl';
    </style>
    